<template>
  <div class="no-scroll">
    <v-snackbar class="pt-6 pr-6" style="z-index: 6 !important" transition="slide-x-reverse-transition"
      v-model="snackbar" :timeout="snackTimeout" :value="true" :color="snackbarclr" absolute outlined top right>
      <v-icon class="mr-2" :color="snackbarclr">mdi-alert-outline</v-icon>
      <span style="white-space: pre-line">{{ snackmsgbar }}</span>
      <v-icon @click="snackbar = false" class="float-right" :color="snackbarclr">mdi-close-circle</v-icon>
    </v-snackbar>
    <LayOut />
    <!-- <v-tabs-items v-model="tab">
      <v-tab-item></v-tab-item>
      <v-tab-item></v-tab-item>
    </v-tabs-items> -->
    <v-container class="px-md-6 pt-14 no-scroll d-block" fluid fill-height style="height: 100vh; overflow: scroll">
      <v-tabs @change="sstTabtype()" height="40px" v-model="tabs">
        <v-tab :disabled="mainloader" class="text-none">KRA</v-tab>
        <v-tab :disabled="mainloader" class="text-none">InstaBO</v-tab>
        <v-tab :disabled="mainloader" class="text-none">KRA log</v-tab>
        <v-tab :disabled="mainloader" class="text-none">CKYC</v-tab>
        <v-tab :disabled="mainloader" class="text-none"> KRA Doc received status</v-tab>
        <v-tab :disabled="mainloader" class="text-none"> Daily Report</v-tab>
        <v-tab :disabled="mainloader" class="text-none"> Exchange </v-tab>
        <v-tab :disabled="mainloader" class="text-none"> Terminal ID </v-tab>
        <v-tab :disabled="mainloader" class="text-none"> EKYC/REKYC Forms </v-tab>
        <v-tab :disabled="mainloader" class="text-none"> Rejection Analysis </v-tab>

      </v-tabs>
      <!-- <v-progress-linear v-if="mainloader" indeterminate class="mb-2"></v-progress-linear> -->
      <v-divider class="mb-3"></v-divider>
      <v-row no-glutters class="pt-sm-2 pb-sm-4" v-if="tabs != 4 && tabs != 7 && tabs != 8 && tabs != 9">
        <v-col v-if="tabs == 3" cols="3">
          <v-form ref="panform" v-model="panvalid" @submit.prevent="panStagevalid()">
            <v-text-field counter="10" :maxlength="10" v-model="panInput" @input="panStagevalid()" dense
              oninput="this.value = this.value.toUpperCase()" :rules="panRule" class="" outlined required>
              <template #prepend>
                <div class="mr-2">
                  <svg xmlns="http://www.w3.org/2000/svg" width="22" height="16" viewBox="0 0 22 16" fill="none">
                    <g clip-path="url(#clip0_944_29)">
                      <path
                        d="M20.1672 0H1.83339C1.33828 0.00820735 0.867127 0.189025 0.523413 0.502731C0.179703 0.816434 -0.00844779 1.23737 0.000291376 1.67308V2.23077H22.0003V1.67308C22.009 1.23737 21.8209 0.816434 21.4772 0.502731C21.1335 0.189025 20.6623 0.00820735 20.1672 0ZM0.000291376 13.9398C-0.00844779 14.3755 0.179703 14.7965 0.523413 15.1102C0.867127 15.4238 1.33828 15.6047 1.83339 15.6129H20.1672C20.6623 15.6047 21.1335 15.4238 21.4772 15.1102C21.8209 14.7965 22.009 14.3755 22.0003 13.9398V3.34553H0.000291376V13.9398ZM13.4444 5.85484C13.4433 5.78227 13.4748 5.71226 13.5321 5.66008C13.5894 5.6079 13.6678 5.57778 13.7503 5.5763H19.2503C19.3327 5.57778 19.4112 5.6079 19.4685 5.66008C19.5258 5.71226 19.5573 5.78227 19.5562 5.85484V6.41253C19.5573 6.48509 19.5258 6.55511 19.4685 6.60729C19.4112 6.65947 19.3327 6.68959 19.2503 6.69107H13.7503C13.6678 6.68959 13.5894 6.65947 13.5321 6.60729C13.4748 6.55511 13.4433 6.48509 13.4444 6.41253V5.85484ZM13.4444 8.085C13.4433 8.0124 13.4748 7.94243 13.5321 7.89019C13.5894 7.83803 13.6678 7.80794 13.7503 7.80645H19.2503C19.3327 7.80794 19.4112 7.83803 19.4685 7.89019C19.5258 7.94243 19.5573 8.0124 19.5562 8.085V8.64266C19.5573 8.71526 19.5258 8.78524 19.4685 8.8374C19.4112 8.88963 19.3327 8.91972 19.2503 8.92121H13.7503C13.6678 8.91972 13.5894 8.88963 13.5321 8.8374C13.4748 8.78524 13.4433 8.71526 13.4444 8.64266V8.085ZM13.4444 10.3152C13.4433 10.2426 13.4748 10.1726 13.5321 10.1204C13.5894 10.0682 13.6678 10.0381 13.7503 10.0366H19.2503C19.3327 10.0381 19.4112 10.0682 19.4685 10.1204C19.5258 10.1726 19.5573 10.2426 19.5562 10.3152V10.8728C19.5573 10.9454 19.5258 11.0154 19.4685 11.0676C19.4112 11.1198 19.3327 11.1499 19.2503 11.1514H13.7503C13.6678 11.1499 13.5894 11.1198 13.5321 11.0676C13.4748 11.0154 13.4433 10.9454 13.4444 10.8728V10.3152ZM6.72236 5.5763C7.37816 5.5979 7.99892 5.84235 8.45425 6.25828C8.9095 6.67421 9.16392 7.22927 9.16392 7.80674C9.16392 8.38427 8.9095 8.93931 8.45425 9.35525C7.99892 9.77119 7.37816 10.0156 6.72236 10.0373C6.06655 10.0156 5.44577 9.77119 4.99049 9.35525C4.53519 8.93931 4.28082 8.38427 4.28082 7.80674C4.28082 7.22927 4.53519 6.67421 4.99049 6.25828C5.44577 5.84235 6.06655 5.5979 6.72236 5.5763ZM2.56294 12.6958C2.71364 12.2544 3.02058 11.8669 3.43903 11.5898C3.85749 11.3127 4.36557 11.1604 4.88926 11.1551H5.20223C5.68178 11.339 6.19926 11.4339 6.72236 11.4339C7.24545 11.4339 7.76295 11.339 8.24248 11.1551H8.55545C9.07912 11.1604 9.58725 11.3127 10.0057 11.5898C10.4241 11.8669 10.7311 12.2544 10.8818 12.6958C10.9066 12.7765 10.91 12.8611 10.8917 12.9431C10.8734 13.0251 10.8339 13.1023 10.7763 13.1687C10.7187 13.2351 10.6445 13.289 10.5594 13.3261C10.4743 13.3632 10.3806 13.3826 10.2856 13.3827H3.15907C3.06381 13.3825 2.96989 13.3629 2.88462 13.3255C2.79935 13.2881 2.72501 13.234 2.66735 13.1673C2.6097 13.1005 2.5703 13.023 2.55219 12.9407C2.53408 12.8584 2.53776 12.7735 2.56294 12.6927V12.6958Z"
                        fill="#666666" />
                    </g>
                    <defs>
                      <clipPath id="clip0_944_29">
                        <rect width="22" height="15.6129" fill="white" />
                      </clipPath>
                    </defs>
                  </svg>
                </div>
              </template>
            </v-text-field>
            <!-- <v-btn color="primary" :disabled="!panvalid" class="white--text text-none">+ Add</v-btn> -->
          </v-form>
        </v-col>
        <v-col v-if="tabs == 3" cols="9" class="d-inline-flex">
          <v-btn class="elevation-0 text-none rounded-lg text-right" height="40px" @click="showdata = []"
            :disabled="!showdata.length > 0" color="grey">Clear</v-btn>

          <v-btn class="elevation-0 text-none rounded-lg ml-4 text-right" height="40px" @click="fileUpload('ckyc')"
            :disabled="!showdata.length > 0" color="success">Upload</v-btn>
        </v-col>

        <v-col v-else-if="tabs != 2 && tabs != 5 && tabs != 6 && tabs != 7 && tabs != 8" cols="3" class="d-inline-flex">
          <v-file-input :disabled="mainloader" :loading="mainloader" hide-details @change="fileUpload" v-model="repfile"
            accept=".xlsx, .xls, .csv" label="Upload only .xlsx, .xls, .csv type files" outlined dense></v-file-input>
          <!-- <v-btn class="elevation-0 text-none rounded-lg ml-4" height="40px" @click="fileUpload()" :disabled="!repfile" color="success">Upload</v-btn> -->
        </v-col>
        <v-col v-if="tabs == 1" cols="3" class="ml-auto text-right"> unused count: {{ showdata.unused_count ?
          showdata.unused_count : "-" }}</v-col>
      </v-row>
      <v-card width="100%" class="elevation-0 rounded-lg" outlined>
        <div v-if="tabs == 0">
          <v-data-table ref="ovrtable" height="calc(100vh - 280px)" dense style="overflow: auto" fixed-header must-sort
            :search="search" :sort-by="['']" :sort-desc="[]" :headers="headers" :items="showdata" :loading="mainloader"
            :footer-props="{
              'items-per-page-options': [10, 30, 50, 100, -1],
            }" :items-per-page="100" class="elevation-0" mobile-breakpoint item-key="sno">
            <template v-slot:top>
              <v-toolbar dense flat>
                <v-file-input prepend-icon="" hide-details dense disabled v-model="dashboarddata" solo flat
                  accept=".csv" label="File name" style="max-width: 200px"></v-file-input>
                ({{ showdata.length }})
                <v-spacer></v-spacer>

                <v-text-field color="#fb8c00" :disabled="mainloader" dense v-model="search" class="rounded-lg"
                  style="max-width: 160px" prepend-inner-icon="mdi-magnify" label="Search" single-line
                  hide-details></v-text-field>

                <v-btn v-if="showdata.length > 0" icon :loading="mainloader" :disabled="mainloader"
                  @click="downloadFile()"><svg xmlns="http://www.w3.org/2000/svg" width="18" height="22"
                    viewBox="0 0 18 22" fill="none">
                    <path
                      d="M11 1.26953V5.40007C11 5.96012 11 6.24015 11.109 6.45406C11.2049 6.64222 11.3578 6.7952 11.546 6.89108C11.7599 7.00007 12.0399 7.00007 12.6 7.00007H16.7305M6 14L9 17M9 17L12 14M9 17L9 11M11 1H5.8C4.11984 1 3.27976 1 2.63803 1.32698C2.07354 1.6146 1.6146 2.07354 1.32698 2.63803C1 3.27976 1 4.11984 1 5.8V16.2C1 17.8802 1 18.7202 1.32698 19.362C1.6146 19.9265 2.07354 20.3854 2.63803 20.673C3.27976 21 4.11984 21 5.8 21H12.2C13.8802 21 14.7202 21 15.362 20.673C15.9265 20.3854 16.3854 19.9265 16.673 19.362C17 18.7202 17 17.8802 17 16.2V7L11 1Z"
                      stroke="#fb8c00" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                  </svg></v-btn>

                <v-btn v-else icon :loading="mainloader" disabled><svg xmlns="http://www.w3.org/2000/svg" width="18"
                    height="22" viewBox="0 0 18 22" fill="none">
                    <path
                      d="M11 1.26953V5.40007C11 5.96012 11 6.24015 11.109 6.45406C11.2049 6.64222 11.3578 6.7952 11.546 6.89108C11.7599 7.00007 12.0399 7.00007 12.6 7.00007H16.7305M6 14L9 17M9 17L12 14M9 17L9 11M11 1H5.8C4.11984 1 3.27976 1 2.63803 1.32698C2.07354 1.6146 1.6146 2.07354 1.32698 2.63803C1 3.27976 1 4.11984 1 5.8V16.2C1 17.8802 1 18.7202 1.32698 19.362C1.6146 19.9265 2.07354 20.3854 2.63803 20.673C3.27976 21 4.11984 21 5.8 21H12.2C13.8802 21 14.7202 21 15.362 20.673C15.9265 20.3854 16.3854 19.9265 16.673 19.362C17 18.7202 17 17.8802 17 16.2V7L11 1Z"
                      stroke="#fb8c00" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                  </svg></v-btn>

                <v-btn icon @click="(showdata = []), (repfile = null)" :loading="mainloader"
                  :disabled="mainloader"><v-icon color="#fb8c00">mdi-refresh</v-icon></v-btn>
              </v-toolbar>
              <v-divider></v-divider>
            </template>

            <template v-slot:[`item.kyc_creatin_date`]="{ item }">
              <span>{{ item.kyc_creatin_date ? item.kyc_creatin_date.slice(0, 16) : "" }}</span>
            </template>
            <template v-slot:[`item.kyc_last_update`]="{ item }">
              <span>{{ item.kyc_last_update ? item.kyc_last_update.slice(0, 16) : "" }}</span>
            </template>
            <template v-slot:[`item.app_modifi_date`]="{ item }">
              <span>{{ item.app_modifi_date ? item.app_modifi_date.slice(0, 16) : "" }}</span>
            </template>

            <template v-slot:[`item.app_ipv_flag_message`]="{ item }">
              <span class="ws-p">{{ item.app_ipv_flag_message ? item.app_ipv_flag_message : "" }}</span>
            </template>
            <template v-slot:[`item.app_update_status_message`]="{ item }">
              <span class="ws-p">{{ item.app_update_status_message ? item.app_update_status_message : "" }}</span>
            </template>
            <template v-slot:[`item.app_status_message`]="{ item }">
              <span class="ws-p">{{ item.app_status_message ? item.app_status_message : "" }}</span>
            </template>
          </v-data-table>
        </div>
        <div v-if="tabs == 1">
          <v-data-table ref="ovrtable" height="calc(100vh - 280px)" dense style="overflow: auto" fixed-header must-sort
            :search="search" :sort-by="['']" :sort-desc="[]" :headers="insheaders" :items="showdata.data"
            :loading="mainloader" :footer-props="{
              'items-per-page-options': [10, 30, 50, 100, -1],
            }" :items-per-page="100" class="elevation-0" mobile-breakpoint item-key="sno">
            <template v-slot:top>
              <v-toolbar dense flat>
                <v-file-input prepend-icon="" hide-details dense disabled v-model="dashboarddata" solo flat
                  accept=".csv" label="File name" style="max-width: 200px"></v-file-input>
                ({{ showdata && showdata.data ? showdata.data.length : "" }})
                <v-spacer></v-spacer>

                <v-text-field color="#fb8c00" :disabled="mainloader" dense v-model="search" class="rounded-lg"
                  style="max-width: 160px" prepend-inner-icon="mdi-magnify" label="Search" single-line
                  hide-details></v-text-field>

                <v-btn v-if="showdata && showdata.data && showdata.data.length > 0" icon :loading="mainloader"
                  :disabled="mainloader" @click="downloadFile()"><svg xmlns="http://www.w3.org/2000/svg" width="18"
                    height="22" viewBox="0 0 18 22" fill="none">
                    <path
                      d="M11 1.26953V5.40007C11 5.96012 11 6.24015 11.109 6.45406C11.2049 6.64222 11.3578 6.7952 11.546 6.89108C11.7599 7.00007 12.0399 7.00007 12.6 7.00007H16.7305M6 14L9 17M9 17L12 14M9 17L9 11M11 1H5.8C4.11984 1 3.27976 1 2.63803 1.32698C2.07354 1.6146 1.6146 2.07354 1.32698 2.63803C1 3.27976 1 4.11984 1 5.8V16.2C1 17.8802 1 18.7202 1.32698 19.362C1.6146 19.9265 2.07354 20.3854 2.63803 20.673C3.27976 21 4.11984 21 5.8 21H12.2C13.8802 21 14.7202 21 15.362 20.673C15.9265 20.3854 16.3854 19.9265 16.673 19.362C17 18.7202 17 17.8802 17 16.2V7L11 1Z"
                      stroke="#fb8c00" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                  </svg></v-btn>

                <v-btn v-else icon :loading="mainloader" disabled><svg xmlns="http://www.w3.org/2000/svg" width="18"
                    height="22" viewBox="0 0 18 22" fill="none">
                    <path
                      d="M11 1.26953V5.40007C11 5.96012 11 6.24015 11.109 6.45406C11.2049 6.64222 11.3578 6.7952 11.546 6.89108C11.7599 7.00007 12.0399 7.00007 12.6 7.00007H16.7305M6 14L9 17M9 17L12 14M9 17L9 11M11 1H5.8C4.11984 1 3.27976 1 2.63803 1.32698C2.07354 1.6146 1.6146 2.07354 1.32698 2.63803C1 3.27976 1 4.11984 1 5.8V16.2C1 17.8802 1 18.7202 1.32698 19.362C1.6146 19.9265 2.07354 20.3854 2.63803 20.673C3.27976 21 4.11984 21 5.8 21H12.2C13.8802 21 14.7202 21 15.362 20.673C15.9265 20.3854 16.3854 19.9265 16.673 19.362C17 18.7202 17 17.8802 17 16.2V7L11 1Z"
                      stroke="#fb8c00" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                  </svg></v-btn>

                <v-btn icon @click="(showdata = []), (repfile = null), getInstaboRep()" :loading="mainloader"
                  :disabled="mainloader"><v-icon color="#fb8c00">mdi-refresh</v-icon></v-btn>
              </v-toolbar>
              <v-divider></v-divider>
            </template>

            <template v-slot:[`item.assign_date`]="{ item }">
              <span>{{ item.assign_date ? item.assign_date.slice(0, 16) : "" }}</span>
            </template>
          </v-data-table>
        </div>
        <div v-if="tabs == 2">
          <v-tabs v-model="kraLogTab" @change="kraLogTabChange()" height="36px">
            <v-tab :disabled="mainloader" class="text-none">Ekyc</v-tab>
            <v-tab :disabled="mainloader" class="text-none">Rekyc</v-tab>
          </v-tabs>
          <v-data-table ref="ovrtable" height="calc(100vh - 320px)" dense style="overflow: auto" fixed-header must-sort
            :search="search" :sort-by="['id']" :sort-desc="[true]" :headers="kraLogHeaders" :items="showdata"
            :loading="mainloader" :footer-props="{
              'items-per-page-options': [10, 30, 50, 100, -1],
            }" :items-per-page="100" class="elevation-0" mobile-breakpoint item-key="sno">
            <template v-slot:top>
              <v-toolbar dense flat>
                {{ showdata.length > 0 ? `(${showdata.length})` : "0" }} logs
                <v-spacer></v-spacer>
                <v-menu v-model="menu22" :close-on-content-click="false" transition="scale-transition" offset-y>
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field v-bind="attrs" v-on="on" readonly color="#fb8c00" :disabled="mainloader" dense
                      v-model="alldate" class="rounded-lg mr-4" style="max-width: 200px"
                      prepend-inner-icon="mdi-calendar" label="Date filter" single-line hide-details> </v-text-field>
                  </template>
                  <v-card width="580px">
                    <v-row no-gutters>
                      <v-col cols="6">
                        <v-date-picker v-model="dateSelect2" :max="maxDate2"></v-date-picker>
                      </v-col>
                      <v-col cols="6">
                        <v-date-picker v-model="dateSelectto" :min="dateSelect2" :max="maxDate2"
                          @input="(menu22 = false), (menu2to = false), dayCustom()"></v-date-picker>
                      </v-col>
                    </v-row>
                  </v-card>
                </v-menu>
                <v-text-field color="#fb8c00" :disabled="mainloader" dense v-model="search" class="rounded-lg"
                  style="max-width: 160px" prepend-inner-icon="mdi-magnify" label="Search" single-line
                  hide-details></v-text-field>

                <v-btn v-if="showdata && showdata.length > 0" icon :loading="mainloader" :disabled="mainloader"
                  @click="downloadFile()"><svg xmlns="http://www.w3.org/2000/svg" width="18" height="22"
                    viewBox="0 0 18 22" fill="none">
                    <path
                      d="M11 1.26953V5.40007C11 5.96012 11 6.24015 11.109 6.45406C11.2049 6.64222 11.3578 6.7952 11.546 6.89108C11.7599 7.00007 12.0399 7.00007 12.6 7.00007H16.7305M6 14L9 17M9 17L12 14M9 17L9 11M11 1H5.8C4.11984 1 3.27976 1 2.63803 1.32698C2.07354 1.6146 1.6146 2.07354 1.32698 2.63803C1 3.27976 1 4.11984 1 5.8V16.2C1 17.8802 1 18.7202 1.32698 19.362C1.6146 19.9265 2.07354 20.3854 2.63803 20.673C3.27976 21 4.11984 21 5.8 21H12.2C13.8802 21 14.7202 21 15.362 20.673C15.9265 20.3854 16.3854 19.9265 16.673 19.362C17 18.7202 17 17.8802 17 16.2V7L11 1Z"
                      stroke="#fb8c00" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                  </svg></v-btn>

                <v-btn v-else icon :loading="mainloader" disabled><svg xmlns="http://www.w3.org/2000/svg" width="18"
                    height="22" viewBox="0 0 18 22" fill="none">
                    <path
                      d="M11 1.26953V5.40007C11 5.96012 11 6.24015 11.109 6.45406C11.2049 6.64222 11.3578 6.7952 11.546 6.89108C11.7599 7.00007 12.0399 7.00007 12.6 7.00007H16.7305M6 14L9 17M9 17L12 14M9 17L9 11M11 1H5.8C4.11984 1 3.27976 1 2.63803 1.32698C2.07354 1.6146 1.6146 2.07354 1.32698 2.63803C1 3.27976 1 4.11984 1 5.8V16.2C1 17.8802 1 18.7202 1.32698 19.362C1.6146 19.9265 2.07354 20.3854 2.63803 20.673C3.27976 21 4.11984 21 5.8 21H12.2C13.8802 21 14.7202 21 15.362 20.673C15.9265 20.3854 16.3854 19.9265 16.673 19.362C17 18.7202 17 17.8802 17 16.2V7L11 1Z"
                      stroke="#fb8c00" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                  </svg></v-btn>

                <v-btn icon @click="(showdata = []), dayCustom()" :loading="mainloader" :disabled="mainloader"><v-icon
                    color="#fb8c00">mdi-refresh</v-icon></v-btn>
              </v-toolbar>
              <v-divider></v-divider>
            </template>

            <template v-slot:[`item.path`]="{ item }">
              <a v-if="item.path" :href="item.path" target="_blank">Download</a>
            </template>

            <template v-slot:[`item.type_detail`]="{ item }">
              <span style="white-space: normal; word-break: break-word">{{ item.type_detail }}</span>
            </template>

            <template v-slot:[`item.now_status`]="{ item }">
              <v-tooltip v-if="item.remarks" bottom color="#000">
                <template v-slot:activator="{ on, attrs }">
                  <span v-bind="attrs" v-on="on">{{ item.now_status }}</span>
                </template>
                <span class="caption">{{ item.remarks }}</span>
              </v-tooltip>

              <span v-else>{{ item.now_status }}</span>
            </template>
            <template v-slot:[`item.datetimes`]="{ item }">
              <span>{{ item.datetimes ? item.datetimes.slice(0, 16) : "" }}</span>
            </template>
            <template v-slot:[`item.s_up_dt`]="{ item }">
              <span>{{ item.s_up_dt ? item.s_up_dt.slice(0, 16) : "" }}</span>
            </template>
            <template v-slot:[`item.doc_recv_dt`]="{ item }">
              <span>{{ item.doc_recv_dt ? item.doc_recv_dt.slice(0, 16) : "" }}</span>
            </template>
          </v-data-table>
        </div>

        <div v-if="tabs == 4">
          <!-- <v-data-table ref="ovrtable" height="calc(100vh - 280px)" dense style="overflow: auto" fixed-header must-sort
            :search="kratrackersearch"  :headers="kratrackerheader" :items="kratrackerres"
            :loading="mainloader" :footer-props="{
              'items-per-page-options': [10, 30, 50, 100, -1],
            }" :items-per-page="100" class="elevation-0" mobile-breakpoint item-key="sno">
            <template v-slot:top>
              <v-toolbar dense flat>
                ({{ kratrackerres && kratrackerres ? kratrackerres.length : "" }})   Kra tracker
                <v-spacer></v-spacer>
                <v-menu v-model="menu22" :close-on-content-click="false" transition="scale-transition" offset-y>
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field v-bind="attrs" v-on="on" readonly color="#fb8c00" :disabled="mainloader" dense
                      v-model="alldatekra" class="rounded-lg mr-4" style="max-width: 200px" @click:clear="dateClear()" clearable
                      prepend-inner-icon="mdi-calendar" label="Date filter" single-line hide-details> </v-text-field>
                  </template>
                  <v-card width="580px">
                    <v-row no-gutters>
                      <v-col cols="6">
                        <v-date-picker v-model="dateSelect2kra" :max="maxDate2kra"></v-date-picker>
                      </v-col>
                      <v-col cols="6">
                        <v-date-picker v-model="dateSelecttokra" :min="dateSelect2kra" :max="maxDate2kra"
                          @input="(menu22 = false), (menu2to = false), dayCustomkratracker()"></v-date-picker>
                      </v-col>
                    </v-row>
                  </v-card>
                </v-menu>
                <v-text-field color="#fb8c00" :disabled="mainloader" dense v-model="kratrackersearch" class="rounded-lg"
                  style="max-width: 160px" prepend-inner-icon="mdi-magnify" label="Search" single-line
                  hide-details></v-text-field>

                  <v-btn icon @click="downloadFilekra()" :loading="mainloader" :disabled="mainloader"><svg xmlns="http://www.w3.org/2000/svg" width="18"
                    height="22" viewBox="0 0 18 22" fill="none">
                    <path
                      d="M11 1.26953V5.40007C11 5.96012 11 6.24015 11.109 6.45406C11.2049 6.64222 11.3578 6.7952 11.546 6.89108C11.7599 7.00007 12.0399 7.00007 12.6 7.00007H16.7305M6 14L9 17M9 17L12 14M9 17L9 11M11 1H5.8C4.11984 1 3.27976 1 2.63803 1.32698C2.07354 1.6146 1.6146 2.07354 1.32698 2.63803C1 3.27976 1 4.11984 1 5.8V16.2C1 17.8802 1 18.7202 1.32698 19.362C1.6146 19.9265 2.07354 20.3854 2.63803 20.673C3.27976 21 4.11984 21 5.8 21H12.2C13.8802 21 14.7202 21 15.362 20.673C15.9265 20.3854 16.3854 19.9265 16.673 19.362C17 18.7202 17 17.8802 17 16.2V7L11 1Z"
                      stroke="#fb8c00" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                  </svg></v-btn>

                <v-btn icon @click="(kratrackerres = []), dayCustomkratracker()" :loading="mainloader" :disabled="mainloader"><v-icon
                    color="#fb8c00">mdi-refresh</v-icon></v-btn>
              </v-toolbar>
              <v-divider></v-divider>
            </template>
            <template v-slot:[`item.filedownload`]="{ item }">
              <a v-if="item.path != ''" :href="`https://ekycbe.mynt.in/dd/`+item.path" target="_blank">Download</a>
            </template>
       
          </v-data-table> -->

          <v-row class="ma-3">
            <v-col cols="4">
              <v-card elevation="0" outlined class="pa-2 text-center">
                <span>Total Fetched</span>
                <p class="mb-0 font-weight-bold">
                  {{ kracountdata.fil_len ? kracountdata.fil_len : 0 }}
                </p>
              </v-card>
            </v-col>
            <v-col cols="4">
              <v-card elevation="0" outlined class="pa-2 text-center">
                <span>Document Received</span>
                <p class="mb-0 font-weight-bold">
                  {{ kracountdata.fil_y ? kracountdata.fil_y : 0 }}
                </p>
              </v-card>
            </v-col>
            <v-col cols="4">
              <v-card elevation="0" outlined class="pa-2 text-center">
                <span>Document Not Received</span>
                <p class="mb-0 font-weight-bold">
                  {{ kracountdata.fil_n ? kracountdata.fil_n : 0 }}
                </p>
              </v-card>
            </v-col>
          </v-row>

          <v-data-table hide-default-header ref="ovrtable" height="calc(90vh - 280px)" dense style="overflow: auto"
            fixed-header must-sort :search="kratrackersearch" :headers="kratrackerheader" :items="filteredItems"
            :loading="mainloader" :footer-props="{
              'items-per-page-options': [10, 30, 50, 100, -1],
            }" :items-per-page="100" class="elevation-0" mobile-breakpoint item-key="sno">
            <template v-slot:top>
              <v-toolbar dense flat>
                ({{ kratrackerres && kratrackerres.length }}) Kra tracker

                <v-spacer></v-spacer>

                <v-menu v-model="menu22" :close-on-content-click="false" transition="scale-transition" offset-y>
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field v-bind="attrs" v-on="on" readonly color="#fb8c00" :disabled="mainloader" dense
                      v-model="alldatekra" class="rounded-lg mr-4" style="max-width: 200px" @click:clear="dateClear()"
                      clearable prepend-inner-icon="mdi-calendar" label="Date filter" single-line
                      hide-details></v-text-field>
                  </template>
                  <v-card width="580px">
                    <v-row no-gutters>
                      <v-col cols="6">
                        <v-date-picker v-model="dateSelect2kra" :max="maxDate2kra" />
                      </v-col>
                      <v-col cols="6">
                        <v-date-picker v-model="dateSelecttokra" :min="dateSelect2kra" :max="maxDate2kra"
                          @input="(menu22 = false), (menu2to = false), dayCustomkratracker()" />
                      </v-col>
                    </v-row>
                  </v-card>
                </v-menu>
                <v-text-field color="#fb8c00" :disabled="mainloader" dense v-model="kratrackersearch" class="rounded-lg"
                  style="max-width: 160px" prepend-inner-icon="mdi-magnify" label="Search" single-line
                  hide-details></v-text-field>
                <v-btn icon @click="downloadFilekra()" :loading="mainloader" :disabled="mainloader"><svg
                    xmlns="http://www.w3.org/2000/svg" width="18" height="22" viewBox="0 0 18 22" fill="none">
                    <path
                      d="M11 1.26953V5.40007C11 5.96012 11 6.24015 11.109 6.45406C11.2049 6.64222 11.3578 6.7952 11.546 6.89108C11.7599 7.00007 12.0399 7.00007 12.6 7.00007H16.7305M6 14L9 17M9 17L12 14M9 17L9 11M11 1H5.8C4.11984 1 3.27976 1 2.63803 1.32698C2.07354 1.6146 1.6146 2.07354 1.32698 2.63803C1 3.27976 1 4.11984 1 5.8V16.2C1 17.8802 1 18.7202 1.32698 19.362C1.6146 19.9265 2.07354 20.3854 2.63803 20.673C3.27976 21 4.11984 21 5.8 21H12.2C13.8802 21 14.7202 21 15.362 20.673C15.9265 20.3854 16.3854 19.9265 16.673 19.362C17 18.7202 17 17.8802 17 16.2V7L11 1Z"
                      stroke="#fb8c00" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                  </svg></v-btn>

                <v-btn icon @click="(kratrackerres = []), dayCustomkratracker()" :loading="mainloader"
                  :disabled="mainloader"><v-icon color="#fb8c00">mdi-refresh</v-icon></v-btn>
              </v-toolbar>
              <v-divider></v-divider>
            </template>

            <template v-slot:[`body.prepend`]>
              <tr style="background-color: #f1f3f8">
                <td v-for="header in kratrackerheader" :key="header.value">
                  <p class="mb-0">
                    {{ header.text }}
                    <v-badge v-if="filters[header.value] && filters[header.value].length > 0" color="primary"
                      :content="filters[header.value] ? filters[header.value].length : 0" class="mr-6 ml-1"> </v-badge>
                    <v-menu offset-y style="max-width: 400px" :close-on-content-click="false">
                      <template v-slot:activator="{ on, attrs }">
                        <v-icon :disabled="mainloader" size="16" v-bind="attrs" v-on="on">mdi-filter-variant</v-icon>
                      </template>
                      <v-card class="elevation-0 rounded-xl">
                        <v-autocomplete chips class="mt-3 custom-autocomplete" hide-details
                          v-if="header.value !== 'filedownload'" v-model="filters[header.value]"
                          :items="uniqueValues(header.value)" :label="header.text" dense outlined clearable multiple>
                          <template v-slot:selection="{ item, index }">
                            <v-chip x-small v-if="index === 0">
                              <span class="caption">{{ item }}</span>
                            </v-chip>
                            <span v-if="index === 1" class="grey--text caption"> (+{{ filters[header.value].length - 1
                            }} others) </span>
                          </template>
                        </v-autocomplete>
                      </v-card>
                    </v-menu>
                  </p>
                </td>
              </tr>
            </template>

            <template v-slot:[`item.filedownload`]="{ item }">
              <a v-if="item.path" :href="`https://ekycbe.mynt.in/file?path=` + item.path" target="_blank"> Download </a>
            </template>
          </v-data-table>
        </div>

        <div v-if="tabs == 3" class="pa-6">
          {{ showdata }}
        </div>

        <div v-if="tabs == 5">
          <div>
            <v-row>

              <v-col cols="6">

                <div class="ma-5">
                  <!-- <div v-if="dailyreportres.msg != 'No data found'"> -->

                  <v-card :loader="comonloader" :disabled="comonloader" data-aos="flip-up" width="100%"
                    class="box-s1 px-md-2 py-1 mt-10 sec-two-sty1 rounded-xl">
                    <v-list-item class="pr-0">
                      <v-list-item-content>
                        <div class="d-flex">
                          <v-menu v-model="menut5" :close-on-content-click="false" :nudge-right="40"
                            transition="scale-transition" offset-y min-width="auto">
                            <template v-slot:activator="{ on, attrs }">
                              <v-text-field :disabled="comonloader" hide-details v-model="date"
                                prepend-icon="mdi-calendar" readonly v-bind="attrs" v-on="on" class="  "
                                style="max-width: 160px"></v-text-field>
                            </template>
                            <v-date-picker v-model="date" @input="menut5 = false"></v-date-picker>
                          </v-menu>
                          <div class="ml-4"> <v-select :items="downloaditem" style="width: 300px !important"
                              label="Select the Report" v-model="selectredata" hide-detail></v-select></div>
                        </div>

                      </v-list-item-content>
                      <v-btn :disabled="comonloader" @click="downloadselectreport()" :loading="comonloader"
                        rel="noopener noreferrer" text plain color="#0037B7"><span
                          class="font-weight-bold text-none fs-16">Download</span></v-btn>
                    </v-list-item>
                  </v-card>


                </div>

              </v-col>
              <v-divider class="mt-5 mb-5" vertical></v-divider>
              <v-col cols="6">

                <div class="ma-6 mt-9">



                  <div v-if="secondreport">

                    <v-card :loading="secondataload" :disabled="secondataload" data-aos="flip-up" width="100%"
                      class="box-s1 pt-6 pb-6  px-md-2 py-1  sec-two-sty1 rounded-xl">
                      <v-list-item class="pr-0">
                        <v-list-item-content>
                          <div class="d-flex">
                            <v-menu v-model="menu22" :close-on-content-click="false" transition="scale-transition"
                              offset-y>
                              <template v-slot:activator="{ on, attrs }">
                                <v-text-field v-bind="attrs" v-on="on" readonly color="#fb8c00"
                                  :disabled="secondataload" dense v-model="alldatekra" class="rounded-lg mr-4"
                                  style="max-width: 200px" prepend-inner-icon="mdi-calendar" label="Date filter"
                                  single-line hide-details></v-text-field>
                              </template>
                              <v-card width="580px">
                                <v-row no-gutters>
                                  <v-col cols="6">
                                    <v-date-picker v-model="dateSelect2kra" :max="maxDate2kra" />
                                  </v-col>
                                  <v-col cols="6">
                                    <v-date-picker v-model="dateSelecttokra" :min="dateSelect2kra" :max="maxDate2kra"
                                      @input="(menu22 = false), (menu2to = false), monthwiserportapi()" />
                                  </v-col>
                                </v-row>
                              </v-card>
                            </v-menu>
                            <div>
                              <v-list-item-title class="font-weight-bold ml-4 fs-20 mt-2">Month Wise
                                Report</v-list-item-title>
                            </div>
                          </div>
                        </v-list-item-content>
                        <v-btn :disabled="secondataload" :href="`https://branchbe.mynt.in/${mothwisres.location}`"
                          target="_blank" rel="noopener noreferrer" text plain color="#0037B7"><span
                            class="font-weight-bold text-none fs-16">Download</span></v-btn>
                      </v-list-item>
                    </v-card>


                  </div>
                  <p v-else class="title font-weight-bold">No Data Found</p>


                </div>
              </v-col>


                <v-col cols="6">

                <div class="ma-6 mt-9">



           
                    <v-card  data-aos="flip-up" width="100%"
                      class="box-s1 pt-6 pb-6  px-md-2 py-1  sec-two-sty1 rounded-xl">
                      <v-list-item class="pr-0">
                        <v-list-item-content>
                          <div class="d-flex">
                            <v-menu v-model="menu223" :close-on-content-click="false" transition="scale-transition"
                              offset-y>
                              <template v-slot:activator="{ on, attrs }">
                                <v-text-field v-bind="attrs" v-on="on" readonly color="#fb8c00"
                                  dense v-model="alldatekra" class="rounded-lg mr-4"
                                  style="max-width: 200px" prepend-inner-icon="mdi-calendar" label="Date filter"
                                  single-line hide-details></v-text-field>
                              </template>
                              <v-card width="580px">
                                <v-row no-gutters>
                                  <v-col cols="6">
                                    <v-date-picker v-model="dateSelect2kra" :max="maxDate2kra" />
                                  </v-col>
                                  <v-col cols="6">
                                    <v-date-picker v-model="dateSelecttokra" :min="dateSelect2kra" :max="maxDate2kra"
                                      @input="(menu223 = false), (menu2to = false)" />
                                  </v-col>
                                </v-row>
                              </v-card>
                            </v-menu>
                            <div>
                              <v-list-item-title class="font-weight-bold ml-4 fs-20 mt-2">KYC Monthly Report </v-list-item-title>
                            </div>
                          </div>
                        </v-list-item-content>
                        <v-btn :loading="kycnewloadeer"  @click="kycdataapicall" rel="noopener noreferrer" text plain color="#0037B7"><span
                            class="font-weight-bold text-none fs-16">Download</span></v-btn>
                      </v-list-item>
                    </v-card>





                </div>
              </v-col>

              <!-- Vendor Verification Report -->
              <v-col cols="6">
                <div class="ma-6 mt-9">
                  <v-card :loading="vendorReportLoader" :disabled="vendorReportLoader" data-aos="flip-up" width="100%"
                    class="box-s1 pt-6 pb-6 px-md-2 py-1 sec-two-sty1 rounded-xl">
                    <v-list-item class="pr-0">
                      <v-list-item-content>
                        <v-list-item-title class="font-weight-bold fs-20 mb-3">Vendor Verification Report</v-list-item-title>
                        <div>
                          <v-menu v-model="vendorMenu" :close-on-content-click="false" transition="scale-transition" offset-y>
                            <template v-slot:activator="{ on, attrs }">
                              <v-text-field v-bind="attrs" v-on="on" readonly color="#fb8c00" :disabled="vendorReportLoader"
                                dense v-model="vendorDateLabel" class="rounded-lg mb-3" style="max-width: 210px"
                                prepend-inner-icon="mdi-calendar" label="Date filter" single-line hide-details></v-text-field>
                            </template>
                            <v-card width="580px">
                              <v-row no-gutters>
                                <v-col cols="6">
                                  <v-date-picker v-model="vendorFrom" :max="maxDate2kra" @input="setVendorDateLabel"></v-date-picker>
                                </v-col>
                                <v-col cols="6">
                                  <v-date-picker v-model="vendorTo" :min="vendorFrom" :max="maxDate2kra" @input="setVendorDateLabel"></v-date-picker>
                                </v-col>
                              </v-row>
                            </v-card>
                          </v-menu>
                          <v-select :items="vendorDocOptions" v-model="vendorDocs" multiple chips small-chips dense
                            item-text="label" item-value="value" label="Document types" :disabled="vendorReportLoader"
                            style="max-width: 300px" hide-details></v-select>
                        </div>
                      </v-list-item-content>
                      <v-btn :loading="vendorReportLoader"
                        :disabled="!vendorFrom || !vendorTo || vendorDocs.length === 0 || vendorReportLoader"
                        @click="downloadVendorReport" text plain color="#0037B7"><span
                          class="font-weight-bold text-none fs-16">Download</span></v-btn>
                    </v-list-item>
                  </v-card>
                </div>
              </v-col>

            </v-row>

            <v-divider></v-divider>

            <v-divider></v-divider>




          </div>
        </div>
        <div v-if="tabs == 6">

          <v-tabs v-model="exchangeTab">
            <v-tab>
              NSE
            </v-tab>
            <v-tab>
              BSE
            </v-tab>

            <v-tabs-items v-model="exchangeTab">
              <v-tab-item>
                <v-card flat class="pa-4 mt-0">
                  <v-toolbar dense flat>
                    <div class="mr-4 font-weight-bold">{{exchangeTab == 0 ? 'NSE' : 'BSE'}} PAN Status</div>
                    <div class="text-caption mr-4" v-html="panSyncHtml"></div>

                    <v-spacer></v-spacer>
                    <v-btn class="mr-2 text-none" elevation="0" color="primary" :loading="panUpdating"
                      :disabled="panUpdating || panSecondsLeft > 0" @click="updatePanStatus()">
                      Update PAN Status
                    </v-btn>
                    <v-chip v-if="panSecondsLeft > 0" small outlined color="#fb8c00" class="mr-4 font-weight-medium">
                      <v-icon x-small left>mdi-timer-sand</v-icon>Available in {{ panCountdown }}
                    </v-chip>
                      <v-btn class="mr-4 text-none" elevation="0" color="primary" @click="openPasswordDialog(0)">
                      Update Password
                    </v-btn>
                    <v-menu v-model="nseMenu" :close-on-content-click="false" transition="scale-transition" offset-y>
                      <template v-slot:activator="{ on, attrs }">
                        <v-text-field v-bind="attrs" v-on="on" readonly color="#fb8c00" :disabled="mainloader" dense
                          v-model="nseDateLabel" class="rounded-lg mr-4" style="max-width: 240px"
                          prepend-inner-icon="mdi-calendar" label="Date filter" single-line hide-details></v-text-field>
                      </template>
                      <v-card width="580px">
                        <v-row no-gutters>
                          <v-col cols="6">
                            <v-date-picker v-model="nseFrom" :max="maxDate2kra"></v-date-picker>
                          </v-col>
                          <v-col cols="6">
                            <v-date-picker v-model="nseTo" :min="nseFrom" :max="maxDate2kra"
                              @input="onNseDateChange"></v-date-picker>
                          </v-col>
                        </v-row>
                      </v-card>
                    </v-menu>
        
                    <v-text-field color="#fb8c00" :disabled="mainloader" dense v-model="nsePanSearch"
                      class="rounded-lg" style="max-width: 200px" prepend-inner-icon="mdi-magnify" label="Search"
                      single-line hide-details></v-text-field>

                    <v-btn v-if="filteredNsePanItems.length > 0" icon :loading="mainloader" :disabled="mainloader"
                      @click="downloadNseExcel()"><svg xmlns="http://www.w3.org/2000/svg" width="18" height="22"
                        viewBox="0 0 18 22" fill="none">
                        <path
                          d="M11 1.26953V5.40007C11 5.96012 11 6.24015 11.109 6.45406C11.2049 6.64222 11.3578 6.7952 11.546 6.89108C11.7599 7.00007 12.0399 7.00007 12.6 7.00007H16.7305M6 14L9 17M9 17L12 14M9 17L9 11M11 1H5.8C4.11984 1 3.27976 1 2.63803 1.32698C2.07354 1.6146 1.6146 2.07354 1.32698 2.63803C1 3.27976 1 4.11984 1 5.8V16.2C1 17.8802 1 18.7202 1.32698 19.362C1.6146 19.9265 2.07354 20.3854 2.63803 20.673C3.27976 21 4.11984 21 5.8 21H12.2C13.8802 21 14.7202 21 15.362 20.673C15.9265 20.3854 16.3854 19.9265 16.673 19.362C17 18.7202 17 17.8802 17 16.2V7L11 1Z"
                          stroke="#fb8c00" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                      </svg></v-btn>
                    <v-btn v-else icon disabled><svg xmlns="http://www.w3.org/2000/svg" width="18" height="22"
                        viewBox="0 0 18 22" fill="none">
                        <path
                          d="M11 1.26953V5.40007C11 5.96012 11 6.24015 11.109 6.45406C11.2049 6.64222 11.3578 6.7952 11.546 6.89108C11.7599 7.00007 12.0399 7.00007 12.6 7.00007H16.7305M6 14L9 17M9 17L12 14M9 17L9 11M11 1H5.8C4.11984 1 3.27976 1 2.63803 1.32698C2.07354 1.6146 1.6146 2.07354 1.32698 2.63803C1 3.27976 1 4.11984 1 5.8V16.2C1 17.8802 1 18.7202 1.32698 19.362C1.6146 19.9265 2.07354 20.3854 2.63803 20.673C3.27976 21 4.11984 21 5.8 21H12.2C13.8802 21 14.7202 21 15.362 20.673C15.9265 20.3854 16.3854 19.9265 16.673 19.362C17 18.7202 17 17.8802 17 16.2V7L11 1Z"
                          stroke="#fb8c00" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                      </svg></v-btn>
                  </v-toolbar>
                  <v-divider class="mb-4"></v-divider>
                  <v-data-table style="border: 1px solid #E0E0E0;" :headers="nsePanHeaders" :items="filteredNsePanItems" :loading="nsePanLoad"
                    :custom-sort="sortPanItems" :sort-by.sync="nsePanSortBy" :sort-desc.sync="nsePanSortDesc"
                    height="calc(60vh)" fixed-header dense :footer-props="{ 'items-per-page-options': [10, 30, 50, 100, -1] }"
                    :items-per-page="50" class="elevation-0" mobile-breakpoint>
                    <template v-slot:[`item.creation_on`]="{ item }">
                      <span style="white-space: nowrap">{{ formatPanDate(item.creation_on, true) }}</span>
                    </template>
                    <template v-slot:[`item.pan_status_date`]="{ item }">
                      <span style="white-space: nowrap">{{ formatPanDate(item.pan_status_date) }}</span>
                    </template>
                  </v-data-table>
                </v-card>
              </v-tab-item>
              <v-tab-item>
                <v-card flat class="pa-4 mt-6">
                  <v-toolbar dense flat>
                    <div class="mr-4 font-weight-bold">{{exchangeTab == 0 ? 'NSE' : 'BSE'}} PAN Status</div>
                    <div class="text-caption mr-4" v-html="panSyncHtml"></div>

                    <v-spacer></v-spacer>
                    <v-btn class="mr-2 text-none" elevation="0" color="primary" :loading="panUpdating"
                      :disabled="panUpdating || panSecondsLeft > 0" @click="updatePanStatus()">
                      Update PAN Status
                    </v-btn>
                    <v-chip v-if="panSecondsLeft > 0" small outlined color="#fb8c00" class="mr-4 font-weight-medium">
                      <v-icon x-small left>mdi-timer-sand</v-icon>Available in {{ panCountdown }}
                    </v-chip>
                      <v-btn class="mr-4 text-none" elevation="0"  color="primary" @click="openPasswordDialog(1)">
                      Update Password
                    </v-btn>
                    <v-menu v-model="bseMenu" :close-on-content-click="false" transition="scale-transition" offset-y>
                      <template v-slot:activator="{ on, attrs }">
                        <v-text-field v-bind="attrs" v-on="on" readonly color="#fb8c00" :disabled="mainloader" dense
                          v-model="bseDateLabel" class="rounded-lg mr-4" style="max-width: 240px"
                          prepend-inner-icon="mdi-calendar" label="Date filter" single-line hide-details></v-text-field>
                      </template>
                      <v-card width="580px">
                        <v-row no-gutters>
                          <v-col cols="6">
                            <v-date-picker v-model="bseFrom" :max="maxDate2kra"></v-date-picker>
                          </v-col>
                          <v-col cols="6">
                            <v-date-picker v-model="bseTo" :min="bseFrom" :max="maxDate2kra"
                              @input="onBseDateChange"></v-date-picker>
                          </v-col>
                        </v-row>
                      </v-card>
                    </v-menu>
                  
                    <v-text-field color="#fb8c00" :disabled="mainloader" dense v-model="bsePanSearch"
                      class="rounded-lg" style="max-width: 200px" prepend-inner-icon="mdi-magnify" label="Search"
                      single-line hide-details></v-text-field>

                    <v-btn v-if="filteredBsePanItems.length > 0" icon :loading="mainloader" :disabled="mainloader"
                      @click="downloadBseExcel()"><svg xmlns="http://www.w3.org/2000/svg" width="18" height="22"
                        viewBox="0 0 18 22" fill="none">
                        <path
                          d="M11 1.26953V5.40007C11 5.96012 11 6.24015 11.109 6.45406C11.2049 6.64222 11.3578 6.7952 11.546 6.89108C11.7599 7.00007 12.0399 7.00007 12.6 7.00007H16.7305M6 14L9 17M9 17L12 14M9 17L9 11M11 1H5.8C4.11984 1 3.27976 1 2.63803 1.32698C2.07354 1.6146 1.6146 2.07354 1.32698 2.63803C1 3.27976 1 4.11984 1 5.8V16.2C1 17.8802 1 18.7202 1.32698 19.362C1.6146 19.9265 2.07354 20.3854 2.63803 20.673C3.27976 21 4.11984 21 5.8 21H12.2C13.8802 21 14.7202 21 15.362 20.673C15.9265 20.3854 16.3854 19.9265 16.673 19.362C17 18.7202 17 17.8802 17 16.2V7L11 1Z"
                          stroke="#fb8c00" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                      </svg></v-btn>
                    <v-btn v-else icon disabled><svg xmlns="http://www.w3.org/2000/svg" width="18" height="22"
                        viewBox="0 0 18 22" fill="none">
                        <path
                          d="M11 1.26953V5.40007C11 5.96012 11 6.24015 11.109 6.45406C11.2049 6.64222 11.3578 6.7952 11.546 6.89108C11.7599 7.00007 12.0399 7.00007 12.6 7.00007H16.7305M6 14L9 17M9 17L12 14M9 17L9 11M11 1H5.8C4.11984 1 3.27976 1 2.63803 1.32698C2.07354 1.6146 1.6146 2.07354 1.32698 2.63803C1 3.27976 1 4.11984 1 5.8V16.2C1 17.8802 1 18.7202 1.32698 19.362C1.6146 19.9265 2.07354 20.3854 2.63803 20.673C3.27976 21 4.11984 21 5.8 21H12.2C13.8802 21 14.7202 21 15.362 20.673C15.9265 20.3854 16.3854 19.9265 16.673 19.362C17 18.7202 17 17.8802 17 16.2V7L11 1Z"
                          stroke="#fb8c00" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                      </svg></v-btn>
                  </v-toolbar>
                  <v-divider class="mb-4"></v-divider>
                  <v-data-table style="border: 1px solid #E0E0E0;" :headers="bsePanHeaders" :items="filteredBsePanItems" :loading="bsePanLoad"
                    :custom-sort="sortPanItems" :sort-by.sync="bsePanSortBy" :sort-desc.sync="bsePanSortDesc"
                    height="calc(60vh)" fixed-header dense :footer-props="{ 'items-per-page-options': [10, 30, 50, 100, -1] }"
                    :items-per-page="50" class="elevation-0" mobile-breakpoint>
                    <template v-slot:[`item.createdon`]="{ item }">
                      <span style="white-space: nowrap">{{ formatPanDate(item.createdon, true) }}</span>
                    </template>
                    <template v-slot:[`item.panvalidationon`]="{ item }">
                      <span style="white-space: nowrap">{{ formatPanDate(item.panvalidationon, true) }}</span>
                    </template>
                  </v-data-table>
                </v-card>
              </v-tab-item>
            </v-tabs-items>

          </v-tabs>

        </div>
        <div v-if="tabs == 7">
          <v-data-table ref="ovrtable" height="calc(100vh - 280px)" dense style="overflow: auto" fixed-header must-sort
            :search="terminalSearch" :headers="terminalHeaders" :items="terminalData" :loading="terminalLoader"
            :footer-props="{
              'items-per-page-options': [10, 30, 50, 100, -1],
            }" :items-per-page="100" class="elevation-0" mobile-breakpoint item-key="id">
            <template v-slot:top>
              <v-toolbar dense flat>
                <div class="font-weight-bold">Terminal ID</div>
                ({{ terminalData.length }})
                <v-spacer></v-spacer>
                <v-text-field color="#fb8c00" :disabled="terminalLoader" dense v-model="terminalSearch"
                  class="rounded-lg mr-4" style="max-width: 160px" prepend-inner-icon="mdi-magnify" label="Search"
                  single-line hide-details></v-text-field>
                <v-btn class="text-none rounded-lg ml-2 mr-2" elevation="0" color="primary" height="32px" @click="openTerminalAdd()">
                  <v-icon small left>mdi-plus</v-icon> Add
                </v-btn>
                <v-btn icon class="ml-1" :loading="terminalLoader" :disabled="terminalLoader"
                  @click="fetchTerminalId()">
                  <v-icon>mdi-refresh</v-icon>
                </v-btn>
              </v-toolbar>
            </template>
            <template v-slot:[`item.action`]="{ item }">
              <v-btn icon small @click="openTerminalEdit(item)">
                <v-icon small>mdi-pencil</v-icon>
              </v-btn>
              <v-btn icon small @click="openTerminalDelete(item)" color="red">
                <v-icon small>mdi-delete</v-icon>
              </v-btn>
            </template>
          </v-data-table>
        </div>
        <div v-if="tabs == 8">
          <v-card flat class="pa-6" style="min-height: calc(100vh - 280px)">
            <div class="font-weight-bold mb-4">EKYC Forms Download</div>
            <v-row>
              <v-col cols="12" sm="4" md="3">
                <v-menu v-model="ekycFormsMenu" :close-on-content-click="false" transition="scale-transition"
                  offset-y min-width="auto">
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field v-model="ekycFormsDate" label="Select Date" prepend-inner-icon="mdi-calendar"
                      readonly outlined dense hide-details v-bind="attrs" v-on="on"
                      :disabled="ekycFormsDownloadLoader"></v-text-field>
                  </template>
                  <v-date-picker v-model="ekycFormsDate" :max="maxDate2"
                    @input="ekycFormsMenu = false; downloadEkycForms()"></v-date-picker>
                </v-menu>
              </v-col>
              <v-col cols="12" sm="4" md="3">
                <v-btn class="text-none rounded-lg" elevation="0" color="primary" height="40px"
                  :loading="ekycFormsDownloadLoader" :disabled="!ekycFormsDate || ekycFormsDownloadLoader"
                  @click="downloadEkycForms()">
                  <v-icon left>mdi-download</v-icon> Download
                </v-btn>
              </v-col>
            </v-row>
            <div class="mt-3 text-caption grey--text">
              Select a date to download the esigned EKYC forms zip for that day.
            </div>

            <v-divider class="my-6"></v-divider>

            <div class="font-weight-bold mb-4">REKYC Forms Download</div>
            <v-row>
              <v-col cols="12" sm="4" md="3">
                <v-menu v-model="rekycFormsMenu" :close-on-content-click="false" transition="scale-transition"
                  offset-y min-width="auto">
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field v-model="rekycFormsDate" label="Select Date" prepend-inner-icon="mdi-calendar"
                      readonly outlined dense hide-details v-bind="attrs" v-on="on"
                      :disabled="rekycFormsDownloadLoader"></v-text-field>
                  </template>
                  <v-date-picker v-model="rekycFormsDate" :max="maxDate2"
                    @input="rekycFormsMenu = false; downloadRekycForms()"></v-date-picker>
                </v-menu>
              </v-col>
              <v-col cols="12" sm="4" md="3">
                <v-btn class="text-none rounded-lg" elevation="0" color="primary" height="40px"
                  :loading="rekycFormsDownloadLoader" :disabled="!rekycFormsDate || rekycFormsDownloadLoader"
                  @click="downloadRekycForms()">
                  <v-icon left>mdi-download</v-icon> Download
                </v-btn>
              </v-col>
            </v-row>
            <div class="mt-3 text-caption grey--text">
              Select a date to download the esigned REKYC forms zip for that day.
            </div>
          </v-card>
        </div>
        <div v-if="tabs == 9">
          <v-card flat class="pa-4" style="min-height: calc(100vh - 280px)">
            <RejectionAnalysis :active="tabs == 9" @notify="onRejectionNotify" />
          </v-card>
        </div>
      </v-card>
    </v-container>

    <v-overlay :value="bottomload" class="rounded-0">
      <div class="text-center">
        <v-progress-circular :size="60" :width="4" color="#0037B7" indeterminate></v-progress-circular>
      </div>
    </v-overlay>

    <!-- Password Update Dialog -->
    <v-dialog v-model="passwordDialog" max-width="600px" persistent>
      <v-card>
        <v-card-title class="headline">
          {{ passwordDialogTab == 0 ? 'NSE' : 'BSE' }} Password Update
          <v-spacer></v-spacer>
          <v-btn icon @click="passwordDialog = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text class="pa-0">
          <!-- NSE Password Update Form -->
          <v-card v-if="passwordDialogTab == 0" flat class="pa-6">
            <!-- <h3 class="mb-4">NSE Password Update</h3> -->
            <v-row>
              <v-col cols="12">
                <v-text-field v-model="nseApiName" label="API Name" outlined dense
                  :disabled="!nseEditMode"></v-text-field>
              </v-col>
              <v-col cols="12">
                <v-text-field v-model="nsePasswordIn" label="Password In" outlined dense type="password"
                  :disabled="!nseEditMode"></v-text-field>
              </v-col>
              <v-col cols="12">
                <v-text-field v-model="nseMemberCode" label="Member Code" outlined dense
                  :disabled="!nseEditMode"></v-text-field>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" v-if="!nseEditMode">
                <v-btn block elevation="0" class="mr-4 text-none" color="primary" @click="toggleNseEdit">
                  Edit
                </v-btn>
              </v-col>
              <v-col cols="12" v-if="nseEditMode">
                <v-btn :loading="nseupdateload" block elevation="0" class="text-none" color="success"
                  :disabled="!nseEditMode" @click="updateNsePassword">
                  Update
                </v-btn>
              </v-col>
            </v-row>
          </v-card>
          <!-- BSE Password Update Form -->
          <v-card v-if="passwordDialogTab == 1" flat class="pa-6">
            <h3 class="mb-4">BSE Password Update</h3>
            <v-row>
              <v-col cols="12">
                <v-text-field v-model="bseMemberCode" label="Member Code" outlined dense
                  :disabled="!bseEditMode"></v-text-field>
              </v-col>
              <v-col cols="12">
                <v-text-field v-model="bsePasswordIn" label="Password In" outlined dense type="password"
                  :disabled="!bseEditMode"></v-text-field>
              </v-col>
              <v-col cols="12">
                <v-text-field v-model="bseUserId" label="User ID" outlined dense
                  :disabled="!bseEditMode"></v-text-field>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" v-if="!bseEditMode">
                <v-btn block elevation="0" class="mr-4 text-none" color="primary" @click="toggleBseEdit">
                  Edit
                </v-btn>
              </v-col>
              <v-col cols="12" v-if="bseEditMode">
                <v-btn :loading="bseupdateload" block elevation="0" class="text-none" color="success"
                  :disabled="!bseEditMode" @click="updateBsePassword">
                  Update
                </v-btn>
              </v-col>
            </v-row>
          </v-card>
        </v-card-text>
      </v-card>
    </v-dialog>

    <!-- Terminal ID Edit Dialog -->
    <v-dialog v-model="terminalDialog" max-width="500px" persistent>
      <v-card>
        <v-card-title class="headline">
          Edit Terminal ID
          <v-spacer></v-spacer>
          <v-btn icon @click="terminalDialog = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-divider></v-divider>
        <v-card flat class="pa-6">
          <v-row>
            <v-col cols="12">
              <v-text-field v-model="terminalEditItem.branch_id" label="Branch ID" outlined dense readonly disabled></v-text-field>
            </v-col>
            <v-col cols="12">
              <v-text-field v-model="terminalEditItem.ap_code" label="AP Code" outlined dense readonly disabled></v-text-field>
            </v-col>
            <v-col cols="12">
              <v-form ref="terminalForm" v-model="terminalFormValid">
                <v-text-field v-model="terminalEditTerminalId" label="Terminal ID" outlined dense
                  oninput="this.value = this.value.toUpperCase().replace(/[^A-Z0-9,]/g, '')"
                  :rules="terminalIdRules"></v-text-field>
              </v-form>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12">
              <v-btn :loading="terminalUpdateLoader" block elevation="0" class="text-none" color="success"
                :disabled="!terminalFormValid || !terminalEditTerminalId" @click="updateTerminalId()">
                Update
              </v-btn>
            </v-col>
          </v-row>
        </v-card>
      </v-card>
    </v-dialog>

    <!-- Terminal ID Add Dialog -->
    <v-dialog v-model="terminalAddDialog" max-width="500px" persistent>
      <v-card>
        <v-card-title class="headline">
          Add Terminal ID
          <v-spacer></v-spacer>
          <v-btn icon @click="terminalAddDialog = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-divider></v-divider>
        <v-card flat class="pa-6">
          <v-form ref="terminalAddForm" v-model="terminalAddFormValid">
            <v-row>
              <v-col cols="12">
                <v-text-field v-model="terminalAddBranchId" label="Branch ID" outlined dense
                  oninput="this.value = this.value.toUpperCase()"
                  :rules="[(v) => !!v || 'Branch ID is required']"></v-text-field>
              </v-col>
              <v-col cols="12">
                <v-text-field v-model="terminalAddApCode" label="AP Code (Optional)" outlined dense
                  oninput="this.value = this.value.toUpperCase()"></v-text-field>
              </v-col>
              <v-col cols="12">
                <v-text-field v-model="terminalAddTerminalId" label="Terminal ID" outlined dense
                  oninput="this.value = this.value.toUpperCase().replace(/[^A-Z0-9,]/g, '')"
                  :rules="terminalIdRules"></v-text-field>
              </v-col>
            </v-row>
          </v-form>
          <v-row>
            <v-col cols="12">
              <v-btn :loading="terminalAddLoader" block elevation="0" class="text-none" color="success"
                :disabled="!terminalAddFormValid" @click="addTerminalId()">
                Add
              </v-btn>
            </v-col>
          </v-row>
        </v-card>
      </v-card>
    </v-dialog>

    <!-- Terminal ID Delete Confirmation Dialog -->
    <v-dialog v-model="terminalDeleteDialog" max-width="400px" persistent>
      <v-card>
        <v-card-title class="headline">
          Delete Terminal ID
          <v-spacer></v-spacer>
          <v-btn icon @click="terminalDeleteDialog = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-divider></v-divider>
        <v-card flat class="pa-6">
          <p class="mb-2">Are you sure you want to delete this terminal ID?</p>
          <p class="mb-1"><b>Branch ID:</b> {{ terminalDeleteItem.branch_id || '-' }}</p>
          <p class="mb-0"><b>AP Code:</b> {{ terminalDeleteItem.ap_code || '-' }}</p>
          <v-row class="mt-2">
            <v-col cols="6">
              <v-btn block elevation="0" class="text-none" @click="terminalDeleteDialog = false">Cancel</v-btn>
            </v-col>
            <v-col cols="6">
              <v-btn block elevation="0" class="text-none" color="red" dark :loading="terminalDeleteLoader" @click="deleteTerminalId()">Delete</v-btn>
            </v-col>
          </v-row>
        </v-card>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { apiinsbo, apidkyc, apikra, apiekyc, apirkyc, apidoc, apiekycdoc } from "../api.js";
import axios from "axios";
import * as XLSX from "xlsx";
import LayOut from "../components/LayOut.vue";
import exportFromJSON from "export-from-json";
import RejectionAnalysis from "./RejectionAnalysis.vue";
export default {
  components: {
    LayOut,
    RejectionAnalysis,
  },

  data: () => ({
    tabs: 0,

    panvalid: false,
    panRule: [(v) => !!v || "PAN number is required", (v) => /[A-Z]{5}[0-9]{4}[A-Z]{1}$/.test(v) || "PAN number must be valid"],
    panInput: "",

    snackbar: false,
    snackbarclr: "default",
    snackmsgbar: "",
    snackTimeout: 5000,
    dashboarddata: [],
    showdata: [],
    search: null,

    mainloader: false,
    bottomload: true,

    uemail: null,
    uuid: null,
    uname: null,

    repfile: null,

    headers: [
      { text: "Name", value: "app_name", width: "8%", class: "ws-p" },
      { text: "PanNumber", value: "app_pan_no", class: "ws-p" },
      { text: "KRA", value: "app_kra", class: "ws-p" },
      { text: "KYC status", value: "app_status_message", class: "ws-p" },
      { text: "KYC remarks", value: "app_status_delta_message", class: "ws-p" },
      { text: "Status date", value: "kyc_last_update", class: "ws-p" },
      { text: "KYC date", value: "kyc_creatin_date", class: "ws-p" },
      { text: "Modify status", value: "app_update_status_message", class: "ws-p" },
      { text: "Modify remarks", value: "app_modifi_hold_deactive_remarks", class: "ws-p" },
      { text: "Modify date", value: "app_modifi_date", class: "ws-p" },
      { text: "KYC mode", value: "app_kyc_mode_message", class: "ws-p" },
      { text: "IPV Flag", value: "app_ipv_flag", class: "ws-p" },
      { text: "UBO details", value: "app_ubo_flag", class: "ws-p" },
      { text: "PERM ADDProof", value: "app_per_add_proof", class: "ws-p" },
      { text: "CORR ADDProof", value: "app_cor_add_proof", class: "ws-p" },
    ],
    insheaders: [
      { text: "Assign date", value: "assign_date", class: "ws-p" },
      { text: "Client ID", value: "clientid", width: "8%", class: "ws-p" },
      { text: "BO ID", value: "bo_id", class: "ws-p" },
      { text: "PanNumber", value: "pan", class: "ws-p" },
      { text: "Date col", value: "date_col", class: "ws-p" },
      { text: "Status", value: "status", class: "ws-p" },
    ],
    kralogheaders: [
      { text: "Id", value: "id", class: "ws-p" },
      { text: "Date", value: "datetimes", class: "ws-p" },
      { text: "Mobile", value: "mobile", width: "8%", class: "ws-p" },
      { text: "PAN", value: "pan", class: "ws-p" },
      { text: "KRA Provider", value: "kra_provoider", class: "ws-p" },
      { text: "Type", value: "type", class: "ws-p" },
      { text: "Modification Details", value: "type_detail", width: "220px", class: "ws-p" },
      { text: "Status updated date", value: "s_up_dt", class: "ws-p" },
      { text: "Status", value: "now_status", class: "ws-p" },
      { text: "Document receive date", value: "doc_recv_dt", class: "ws-p" },
      { text: "link", value: "path", class: "ws-p" },
    ],
    kratrackerheader: [
      { text: "Pan", value: "PAN", class: "ws-p" },
      { text: "Date of fetching", value: "Date of fetching", class: "ws-p" },
      { text: "KRA Provider", value: "KRA Provider", width: "10%", class: "ws-p" },
      { text: "KYC Form Approved status", value: "KYC Form Approved status", width: "10%", class: "ws-p" },
      { text: "Initial KRA Doc received status", value: "Initial KRA Doc received status", width: "8%", class: "ws-p" },
      { text: "Date of received", value: "Date of received", class: "ws-p" },
      { text: "file download", value: "filedownload", class: "ws-p" },
    ],
    kratrackersearch: "",
    kraLogTab: 0,
    alldate: null,
    menu2: false,
    menu22: false,
    menu223: false,
    menu2to: false,

    dateSelect2: new Date(new Date().getFullYear(), new Date().getMonth() - 1, new Date().getDate()).toISOString().slice(0, 10),
    dateSelectto: new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate() + 1).toISOString().slice(0, 10),
    maxDate2: new Date(Date.now() - new Date().getTimezoneOffset() * 60000).toISOString().substr(0, 10),
    alldatekra: null,
    dateSelect2kra: new Date(new Date().getFullYear(), new Date().getMonth() - 1, new Date().getDate()).toISOString().slice(0, 10),
    dateSelecttokra: new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate() + 1).toISOString().slice(0, 10),
    maxDate2kra: new Date(Date.now() - new Date().getTimezoneOffset() * 60000).toISOString().substr(0, 10),

    // Vendor Verification Report
    vendorMenu: false,
    vendorFrom: new Date(new Date().getFullYear(), new Date().getMonth() - 1, new Date().getDate()).toISOString().slice(0, 10),
    vendorTo: new Date(Date.now() - new Date().getTimezoneOffset() * 60000).toISOString().substr(0, 10),
    vendorDateLabel: "",
    vendorDocs: [],
    vendorReportLoader: false,
    vendorDocOptions: [
      { value: "penny", label: "Razorpay Penny Drop" },
      { value: "rev-penny", label: "Setu Reverse Penny Drop" },
      { value: "sign", label: "Signature (Hyperverge)" },
      { value: "selfie", label: "Selfie / IPV (Hyperverge)" },
      { value: "nom-opt-out", label: "Nominee Opt-Out (Hyperverge)" },
    ],

    kratrackerres: [], // Your data
    filters: {},
    kracountdata: "",
    menut5: false,
    date: new Date(new Date().getTime() - 24 * 60 * 60 * 1000).toISOString().substr(0, 10),
    dateRange: "",
    firstvisible: true,
    secondreport: true,
    secondataload: false,
    mothwisres: [],
    reatvatinloda: false,
    reativatoires: [],
    menurt: false,
    datetr: new Date(new Date().getTime() - (24 * 60 * 60 * 1000)).toISOString().substr(0, 10),
    menurt1: false,
    datetr1: new Date(new Date().getTime() - (24 * 60 * 60 * 1000)).toISOString().substr(0, 10),
    thirdvisible: true,
    rekycreportload: true,
    rekycrepotdata: "",
    downloaditem: ["Master code report", "New Old RM Report", "Reactivation report", "REKYC Report", "Overall Report"],
    selectredata: "",
    comonloader: false,
    dailyreportres: [],

    // NSE Password Update
    nseEditMode: false,
    nseApiName: "",
    nsePasswordIn: "",
    nseMemberCode: "",
    nseupdateload: false,

    // BSE Password Update
    bseEditMode: false,
    bseMemberCode: "",
    bsePasswordIn: "",
    bseUserId: "",
    bseupdateload: false,

    // Terminal ID
    terminalLoader: false,
    terminalSearch: "",
    terminalData: [],
    terminalHeaders: [
      { text: "ID", value: "id", class: "ws-p" },
      { text: "AP Code", value: "ap_code", class: "ws-p" },
      { text: "Branch ID", value: "branch_id", class: "ws-p" },
      { text: "Terminal ID", value: "terminal_id", class: "ws-p" },
      // { text: "Log", value: "log", class: "ws-p" },
      { text: "Action", value: "action", sortable: false, class: "ws-p" },
    ],
    terminalDialog: false,
    terminalEditItem: {},
    terminalEditTerminalId: "",
    terminalFormValid: false,
    terminalUpdateLoader: false,
    terminalAddDialog: false,
    terminalAddBranchId: "",
    terminalAddApCode: "",
    terminalAddTerminalId: "",
    terminalAddFormValid: false,
    terminalAddLoader: false,
    terminalDeleteDialog: false,
    terminalDeleteItem: {},
    terminalDeleteLoader: false,
    terminalIdRules: [
      (v) => !!v || "Terminal ID is required",
      (v) => /^[A-Z0-9,]+$/.test(v) || "Only uppercase letters, numbers and commas allowed",
    ],

    // EKYC Forms Download
    ekycFormsDate: "",
    ekycFormsMenu: false,
    ekycFormsDownloadLoader: false,

    // REKYC Forms Download
    rekycFormsDate: "",
    rekycFormsMenu: false,
    rekycFormsDownloadLoader: false,

    // Exchange Tab Index
    exchangeTab: 0,

    // Password Update Dialog
    passwordDialog: false,
    passwordDialogTab: 0,

    // NSE PAN Status Table
    nsePanLoad: false,
    nsePanSortBy: ['creation_on'],
    nsePanSortDesc: [true],
    bsePanSortBy: ['createdon'],
    bsePanSortDesc: [true],
    nseMenu: false,
    nsePanSearch: "",
    nsePanData: [],
    nseFrom: "",
    nseTo: "",
    nseDateLabel: "",
nsePanHeaders: [
  { text: "ID", value: "id", class: "ws-p" },
  { text: "Client Code", value: "client_code", class: "ws-p" },
  { text: "Client Name", value: "client_name", class: "ws-p" },
  { text: "Aadhaar Seed", value: "adhr_seeding_status", class: "ws-p" },
  { text: "Created On", value: "creation_on", class: "ws-p" },
  { text: "Name on PAN", value: "pan_name_matching_status", class: "ws-p" },
  { text: "PAN Name", value: "pan_name_matching_status", class: "ws-p" },
  { text: "PAN No", value: "pan", class: "ws-p" },
  { text: "PAN Status", value: "pan_status", class: "ws-p" },
  { text: "Active Status", value: "exchange_status", class: "ws-p" },
  { text: "PAN Validation On", value: "pan_status_date", class: "ws-p" },
  { text: "Segment", value: "segment", class: "ws-p" },

],


    // BSE PAN Status Table
    bsePanLoad: false,
    bseMenu: false,
    bsePanSearch: "",
    bsePanData: [],
    bseFrom: "",
    bseTo: "",
    bseDateLabel: "",
    bsePanHeaders: [
      { text: "ID", value: "id", class: "ws-p" },
      { text: "Client Code", value: "clientcode", class: "ws-p" },
      { text: "Client Name", value: "clientname", class: "ws-p" },
      { text: "Aadhaar Seed", value: "aadhaar_seed_flag", class: "ws-p" },
      { text: "Created On", value: "createdon", class: "ws-p" },
      { text: "Name on PAN", value: "name_on_pancard", class: "ws-p" },
      { text: "PAN Name", value: "panname", class: "ws-p" },
      { text: "PAN No", value: "panno", class: "ws-p" },
      { text: "PAN Status", value: "panstatus", class: "ws-p" },
      { text: "Active Status", value: "active_status", class: "ws-p" },
      { text: "PAN Validation On", value: "panvalidationon", class: "ws-p" },
    ],
    kycnewloadeer:false,

    // PAN status sync
    panSync: null,
    panUpdating: false,
    panNow: Date.now(),
    panTimer: null,
    panPollTimer: null,

  }),
  created() {
    document.title = "report-services";
    this.setVendorDateLabel();
  },
  mounted() {
    let list = atob(localStorage.getItem("stapilist"));
    this.uemail = localStorage.getItem("email");
    this.uuid = localStorage.getItem("empcode");
    this.uname = localStorage.getItem("name");
    if (this.uemail && this.uuid && this.uname && (this.uemail.split("@")[1] == "zebuetrade.com" || (list && this.getemailInList(this.uemail, "emailId", list)))) {
      this.bottomload = false;
      this.mainloader = false;
    }
    // this.dateRange = `${this.formatDate(this.fromdate)} ~ ${this.formatDate(this.todate)}`;
    this.panTimer = setInterval(() => { this.panNow = Date.now() }, 1000);
    // pick up the automatic (every 2 hours) runs while the page is open
    this.panPollTimer = setInterval(() => { if (this.tabs == 6) this.loadPanSyncStatus() }, 5 * 60 * 1000);
  },
  beforeDestroy() {
    clearInterval(this.panTimer);
    clearInterval(this.panPollTimer);
  },
  methods: {
    // server time (IST, no timezone) -> Date; trimmed to milliseconds for Safari
    parsePanSyncDate(v) {
      return new Date(String(v).slice(0, 23))
    },
    showPanSnack(color, lines, timeout) {
      // reuses the page's existing snackbar; timeout -1 keeps it open until closed
      this.snackbar = false
      this.$nextTick(() => {
        this.snackTimeout = timeout
        this.snackbarclr = color
        this.snackmsgbar = lines.join('\n')
        this.snackbar = true
      })
    },
    loadPanSyncStatus() {
      const axios = require('axios');
      return axios.get(`${apikra}dashboard/scheduler_job_status`)
        .then((response) => {
          const rows = response?.data?.data || []
          this.panSync = rows.find((r) => r.job_name === 'NSE_BSE_PAN_STATUS') || null
        })
        .catch(() => {
          this.panSync = null // 404 = not updated yet
        })
    },
    updatePanStatus() {
      const axios = require('axios');
      this.panUpdating = true
      this.showPanSnack('info', ['Updating NSE and BSE PAN status…'], -1)
      return axios.post(`${apikra}dashboard/Nse_Pan_status_update`, null, { timeout: 240000 })
        .then((response) => {
          const data = response.data
          const failed = ['NSE', 'BSE'].filter((x) => data?.result?.[x]?.status === 'failure')
          if (data.status === 'success' && failed.length === 0) {
            this.showPanSnack('success', [data.msg], 4000)
          } else {
            const lines = [data.msg, ...['NSE', 'BSE'].map((x) => {
              const r = data?.result?.[x]
              if (r?.status === 'success') return `${x}: updated`
              const errs = (r?.errors || []).map((e) => String(e).replace(' :: ', ': ')).join(', ')
              return `${x}: ${errs}`
            })]
            this.showPanSnack(failed.length === 1 ? 'warning' : 'error', lines, -1)
          }
        })
        .catch((error) => {
          if (error.code === 'ECONNABORTED' || error.response?.status === 504) {
            this.showPanSnack('info', ['Update is taking longer than usual. The status will refresh shortly.'], 6000)
            setTimeout(() => { this.loadPanSyncStatus(); this.fetchNseBsePanStatus(0); this.fetchNseBsePanStatus(1) }, 60000)
          } else {
            this.showPanSnack('error', ['Update could not run. Please try again later.'], 6000)
          }
        })
        .then(() => {
          this.panUpdating = false
          // one click updates both exchanges, so refresh both tables
          return Promise.all([this.loadPanSyncStatus(), this.fetchNseBsePanStatus(0), this.fetchNseBsePanStatus(1)])
        })
    },
    // "2026-10-21T13:15:13" -> "21 Oct 2026, 01:15 PM" (time omitted for date-only values or withTime=false)
    formatPanDate(val, withTime = false) {
      if (!val) return ''
      const m = String(val).match(/^(\d{4})-(\d{2})-(\d{2})(?:[T ](\d{2}):(\d{2}))?/)
      if (!m) return String(val)
      const mon = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'][+m[2] - 1]
      const date = `${m[3]} ${mon} ${m[1]}`
      if (!withTime || !m[4]) return date
      const h = +m[4]
      const h12 = h % 12 || 12
      return `${date}, ${String(h12).padStart(2, '0')}:${m[5]} ${h < 12 ? 'AM' : 'PM'}`
    },
    // ISO date strings are compared as timestamps; other columns as text/numbers
    sortPanItems(items, sortBy, sortDesc) {
      const dateCols = ['createdon', 'panvalidationon', 'creation_on', 'pan_status_date']
      const toVal = (v, isDate) => {
        if (v === null || v === undefined || v === '') return null
        if (isDate) {
          const t = Date.parse(v)
          return isNaN(t) ? null : t
        }
        return typeof v === 'number' ? v : String(v).toLowerCase()
      }
      if (!sortBy || !sortBy.length) return items
      return [...items].sort((a, b) => {
        for (let i = 0; i < sortBy.length; i++) {
          const key = sortBy[i]
          const isDate = dateCols.includes(key)
          let x = toVal(a[key], isDate)
          let y = toVal(b[key], isDate)
          if (sortDesc[i]) [x, y] = [y, x]
          if (x === y) continue
          if (x === null) return -1
          if (y === null) return 1
          return x < y ? -1 : 1
        }
        return 0
      })
    },
  onRejectionNotify({ msg, color }) {
    this.snackmsgbar = msg;
    this.snackbarclr = color === 'error' ? 'red' : color === 'warning' ? 'warning' : 'success';
    this.snackbar = true;
  },
  setVendorDateLabel() {
    if (this.vendorFrom && this.vendorTo) {
      const from = new Date(this.vendorFrom).toDateString().slice(4);
      const to = new Date(this.vendorTo).toDateString().slice(4);
      this.vendorDateLabel = `${from.slice(0, 6)} ~ ${to}`;
      this.vendorMenu = false;
    }
  },
  // Excel sheet names must be <= 31 chars and cannot contain [ ] : * ? / \
  sanitizeSheetName(name, fallback) {
    const cleaned = String(name || "").replace(/[[\]:*?/\\]/g, " ").trim().slice(0, 31);
    return cleaned || String(fallback || "Sheet").slice(0, 31);
  },
  downloadVendorReport() {
    if (!this.vendorFrom || !this.vendorTo || this.vendorDocs.length === 0) return;
    this.vendorReportLoader = true;
    let axiosThis = this;
    axios({
      method: "post",
      url: `${apidkyc}/vendor_verification_report`,
      headers: { "Content-Type": "application/json" },
      // doc may be a single value or an array; the backend accepts both
      data: { from: this.vendorFrom, to: this.vendorTo, doc: this.vendorDocs },
    })
      .then((response) => {
        const data = response.data || {};
        const wb = XLSX.utils.book_new();
        const usedNames = new Set();

        // One sheet per requested doc key, using `columns` for header order
        Object.keys(data).forEach((doc) => {
          const entry = data[doc] || {};
          const columns = Array.isArray(entry.columns) ? entry.columns : [];
          const rows = Array.isArray(entry.rows) ? entry.rows : [];

          // header row first, then rows mapped in that exact column order
          const ws = XLSX.utils.aoa_to_sheet([columns]);
          if (rows.length) {
            XLSX.utils.sheet_add_json(ws, rows, {
              header: columns,
              skipHeader: true,
              origin: -1,
            });
          }

          // unique, Excel-safe sheet name: {vendor}-{doc}
          const base = axiosThis.sanitizeSheetName(`${entry.vendor || ""}-${doc}`, doc);
          let candidate = base;
          let n = 2;
          while (usedNames.has(candidate)) {
            const suffix = `-${n}`;
            candidate = base.slice(0, 31 - suffix.length) + suffix;
            n += 1;
          }
          usedNames.add(candidate);

          XLSX.utils.book_append_sheet(wb, ws, candidate);
        });

        if (!wb.SheetNames.length) {
          axiosThis.snackbarclr = "warning";
          axiosThis.snackmsgbar = "No data returned for the selected report.";
          axiosThis.snackbar = true;
          return;
        }

        XLSX.writeFile(wb, `vendor_report_${axiosThis.vendorFrom}_to_${axiosThis.vendorTo}.xlsx`);
        axiosThis.snackbarclr = "success";
        axiosThis.snackmsgbar = "Vendor verification report downloaded.";
        axiosThis.snackbar = true;
      })
      .catch((error) => {
        // error path returns JSON: { msg, error }
        let msg = "Export failed";
        const resp = error.response && error.response.data;
        if (resp && (resp.msg || resp.error)) {
          msg = resp.msg || resp.error;
        } else if (error.message) {
          msg = error.message;
        }
        axiosThis.snackbarclr = "red";
        axiosThis.snackmsgbar = msg;
        axiosThis.snackbar = true;
      })
      .finally(() => {
        axiosThis.vendorReportLoader = false;
      });
  },
  kycdataapicall(){
    this.kycnewloadeer = true
const axios = require('axios');
let date = this.dateSelect2kra;
let parts = date.split("-"); 
let newfrom = `${parts[2]}/${parts[1]}/${parts[0]}`;

let dateto = this.dateSelecttokra;
let partsto = dateto.split("-"); 
let newto = `${partsto[2]}/${partsto[1]}/${partsto[0]}`;

let data = JSON.stringify({
  "from_date":newfrom,
  "to_date": newto
});

let config = {
  method: 'post',
  maxBodyLength: Infinity,
  url: 'https://ekycbe.mynt.in/dashboard/kyc_month_data',
  headers: { 
    'Content-Type': 'application/json'
  },
  data : data
};
var axiosThis = this
axios.request(config)
.then((response) => {
  // console.log(JSON.stringify(response.data));
  axiosThis.kycnewloadeer = false
  if(response.data.file_path){
    const relativePath = response.data.file_path.split("static/")[1];
   window.open("https://ekycbe.mynt.in/static/" + relativePath, "_blank");
  }else{
  axiosThis.snackbar = true;
          axiosThis.snackbarclr = "red";
          axiosThis.snackmsgbar = response.data;
  }


})
.catch((error) => {
  console.log(error);
  axiosThis.kycnewloadeer = false
axiosThis.snackbar = true;
          axiosThis.snackbarclr = "red";
          axiosThis.snackmsgbar = error;
});

  },
    nsepassgetdata() {
      const axios = require('axios');
      let data = JSON.stringify({
        "exchange": "NSE",
        "status": "get"
      });

      let config = {
        method: 'post',
        maxBodyLength: Infinity,
        url: `${apikra}dashboard/nse_bse_password_update`,
        headers: {
          'Content-Type': 'application/json'
        },
        data: data
      };
      var axiosThis = this
      axios.request(config)
        .then((response) => {
          console.log(JSON.stringify(response.data));
          if (response.data.data) {
            axiosThis.nseMemberCode = response?.data?.data?.membercode || '';
            axiosThis.nsePasswordIn = response?.data?.data?.password_in || '';
            axiosThis.nseApiName = response?.data?.data?.apiname || '';


          }
        })
        .catch((error) => {
          console.log(error);
          axiosThis.snackbar = true;
          axiosThis.snackbarclr = "red";
          axiosThis.snackmsgbar = error;
        });

    },
    toggleNseEdit() {
      this.nseEditMode = !this.nseEditMode;
    },
    openPasswordDialog(tab) {
      this.passwordDialogTab = tab;
      this.passwordDialog = true;
    },
    updateNsePassword() {
      this.nseupdateload = true
      // const updateData = {
      //   apiname: this.nseApiName,
      //   password_in: this.nsePasswordIn,
      //   membercode: this.nseMemberCode
      // };
      // console.log(updateData);

      const axios = require('axios');
      let data = JSON.stringify({
        "exchange": "NSE",
        "status": "update",
        "membercode": this.nseMemberCode,
        "password": this.nsePasswordIn,
        "apiname": this.nseApiName
      });

      let config = {
        method: 'post',
        maxBodyLength: Infinity,
        url: `${apikra}dashboard/nse_bse_password_update`,
        headers: {
          'Content-Type': 'application/json'
        },
        data: data
      };
      var axiosThis = this
      axios.request(config)
        .then((response) => {
          // console.log(JSON.stringify(response.data));
          axiosThis.nseupdateload = false
          if (response.data.msg) {
            axiosThis.nsepassgetdata()
            axiosThis.snackbar = true;
            axiosThis.snackbarclr = "green";
            axiosThis.snackmsgbar = response.data.msg;
            axiosThis.nseEditMode = false;
            axiosThis.passwordDialog = false;
          } else {
            axiosThis.snackbar = true;
            axiosThis.snackbarclr = "red";
            axiosThis.snackmsgbar = response.data;
          }
        })
        .catch((error) => {
          console.log(error);
          axiosThis.nseupdateload = false
          axiosThis.snackbar = true;
          axiosThis.snackbarclr = "red";
          axiosThis.snackmsgbar = error;

        });
    },
    setRangeLabel(exchange) {
      if (exchange === 'NSE') {
        if (new Date(this.nseFrom) && new Date(this.nseTo)) {
          let dateis = `${new Date(this.nseFrom).toDateString().slice(3)} ${new Date(this.nseFrom).toLocaleString('en-US', { hour: 'numeric', minute: 'numeric', hour12: true })}`;
          let dateto = `${new Date(this.nseTo).toDateString().slice(3)} ${new Date(this.nseTo).toLocaleString('en-US', { hour: 'numeric', minute: 'numeric', hour12: true })}`;
          this.nseDateLabel = `${dateis.slice(0, 7)} ~ ${dateto.slice(0, 12)}`;
        }
      } else {
        if (new Date(this.bseFrom) && new Date(this.bseTo)) {
          let dateis = `${new Date(this.bseFrom).toDateString().slice(3)} ${new Date(this.bseFrom).toLocaleString('en-US', { hour: 'numeric', minute: 'numeric', hour12: true })}`;
          let dateto = `${new Date(this.bseTo).toDateString().slice(3)} ${new Date(this.bseTo).toLocaleString('en-US', { hour: 'numeric', minute: 'numeric', hour12: true })}`;
          this.bseDateLabel = `${dateis.slice(0, 7)} ~ ${dateto.slice(0, 12)}`;
        }
      }
    },
    onNseDateChange() {
      this.setRangeLabel('NSE');
      this.nseMenu = false;
      this.fetchNseBsePanStatus();
    },
    onBseDateChange() {
      this.setRangeLabel('BSE');
      this.bseMenu = false;
      this.fetchNseBsePanStatus();
    },
    fetchNseBsePanStatus(tab = this.exchangeTab) {
      // capture the tab at request time so a late response never lands in the other table
      const isNse = tab == 0;
      if (isNse) this.nsePanLoad = true; else this.bsePanLoad = true;
      const axios = require('axios');
      const toDDMMYYYY = (iso) => {
        if (!iso) return "";
        const d = new Date(iso);
        const dd = String(d.getDate()).padStart(2, '0');
        const mm = String(d.getMonth() + 1).padStart(2, '0');
        const yyyy = d.getFullYear();
        return `${dd}/${mm}/${yyyy}`;
      };
      const fromDate = isNse ? this.nseFrom : this.bseFrom;
      const toDate = isNse ? this.nseTo : this.bseTo;
      let data = JSON.stringify({
        "exchange": isNse ? 'NSE' : 'BSE',
        "from": toDDMMYYYY(fromDate),
        "to": toDDMMYYYY(toDate)
      });

      let config = {
        method: 'post',
        maxBodyLength: Infinity,
        url: `${apikra}dashboard/Nse_bse_Pan_status_get`,
        headers: {
          'Content-Type': 'application/json'
        },
        data: data
      };
      var axiosThis = this
      axios.request(config)
        .then((response) => {
          // console.log(JSON.stringify(response.data));
          if (isNse) {
            axiosThis.nsePanLoad = false
            axiosThis.nsePanData = response?.data?.data || []
          } else {
            axiosThis.bsePanLoad = false
            axiosThis.bsePanData = response?.data?.data || []
          }
        })
        .catch((error) => {
          console.log(error);
          if (isNse) axiosThis.nsePanLoad = false; else axiosThis.bsePanLoad = false;
          if(error.response?.data?.msg){
            axiosThis.snackbar = true;
          axiosThis.snackbarclr = "orange";
          axiosThis.snackmsgbar = (isNse ? 'NSE' : 'BSE') + " " +  error.response.data.msg;
          }else{
                      axiosThis.snackbar = true;
          axiosThis.snackbarclr = "red";
          axiosThis.snackmsgbar = error;
          }

        });
    },
    bsepassgetdata() {
      const axios = require('axios');
      let data = JSON.stringify({
        "exchange": "BSE",
        "status": "get"
      });

      let config = {
        method: 'post',
        maxBodyLength: Infinity,
        url: `${apikra}dashboard/nse_bse_password_update`,
        headers: {
          'Content-Type': 'application/json'
        },
        data: data
      };
      var axiosThis = this
      axios.request(config)
        .then((response) => {
          console.log(JSON.stringify(response.data));
          if (response.data.data) {
            axiosThis.bseMemberCode = response?.data?.data?.membercode || '';
            axiosThis.bsePasswordIn = response?.data?.data?.password_in || '';
            axiosThis.bseUserId = response?.data?.data?.userid || '';
          }
        })
        .catch((error) => {
          console.log(error);
          axiosThis.snackbar = true;
          axiosThis.snackbarclr = "red";
          axiosThis.snackmsgbar = error;
        });
    },
    toggleBseEdit() {
      this.bseEditMode = !this.bseEditMode;
    },
    updateBsePassword() {
      this.bseupdateload = true
      const axios = require('axios');
      let data = JSON.stringify({
        "exchange": "BSE",
        "status": "update",
        "membercode": this.bseMemberCode,
        "password": this.bsePasswordIn,
        "userid": this.bseUserId
      });

      let config = {
        method: 'post',
        maxBodyLength: Infinity,
        url: `${apikra}dashboard/nse_bse_password_update`,
        headers: {
          'Content-Type': 'application/json'
        },
        data: data
      };
      var axiosThis = this
      axios.request(config)
        .then((response) => {
          // console.log(JSON.stringify(response.data));
          axiosThis.bseupdateload = false
          if (response.data.msg) {
            axiosThis.bsepassgetdata()
            axiosThis.snackbar = true;
            axiosThis.snackbarclr = "green";
            axiosThis.snackmsgbar = response.data.msg;
            axiosThis.bseEditMode = false;
            axiosThis.passwordDialog = false;
          } else {
            axiosThis.snackbar = true;
            axiosThis.snackbarclr = "red";
            axiosThis.snackmsgbar = response.data;
          }
        })
        .catch((error) => {
          console.log(error);
          axiosThis.bseupdateload = false
          axiosThis.snackbar = true;
          axiosThis.snackbarclr = "red";
          axiosThis.snackmsgbar = error;
        });
    },

    rekycreport() {
      this.comonloader = true
      this.rekycrepotdata = ""
      this.rekycreportload = true
      const axios = require('axios');
      let data = JSON.stringify({
        "date": this.date
      });

      let config = {
        method: 'post',
        maxBodyLength: Infinity,
        url: 'https://rekycbe.mynt.in/rekyc_reports',
        headers: {
          'Content-Type': 'application/json'
        },
        data: data
      };
      var axiosThis = this
      axios.request(config)
        .then((response) => {
          axiosThis.comonloader = false

          axiosThis.rekycreportload = false
          // console.log(JSON.stringify(response.data));
          if (response.data.stat == "Ok") {
            axiosThis.rekycrepotdata = response.data.location
            if (axiosThis.selectredata == "REKYC Report") {
              window.open("https://rekycbe.mynt.in/" + response.data.location, "_blank");
            }
          } else {
            axiosThis.snackbar = true;
            axiosThis.snackbarclr = "red";
            axiosThis.snackmsgbar = response.data;
          }
        })
        .catch((error) => {
          console.log(error);
          axiosThis.snackbar = true;
          axiosThis.comonloader = false
          axiosThis.snackbarclr = "red";
          axiosThis.snackmsgbar = error;
          axiosThis.rekycreportload = false

        });

    },
    getemailInList(email, value, list) {
      const rawData = JSON.parse(list);
      return rawData.some((item) => item[value].toUpperCase() === email.toUpperCase());
    },
    uniqueValues(key) {
      const values = this.kratrackerres.map((item) => item[key]).filter((value) => value !== null && value !== undefined); // Keeps empty strings ("") but filters out null and undefined
      return [...new Set(values)];
    },

    fileUpload() {
      if (this.tabs == 3) {
        var log = JSON.stringify({ email: this.uemail, UID: this.uuid, name: this.uname });
        window.open(`${apikra}/kra/getFileCKYC?panlist=${JSON.stringify(this.showdata)}&log=${log}`, "_blank");
        this.showdata = [];
      } else {
        this.showdata = [];
        if (this.repfile) {
          this.mainloader = true;
          let formData = new FormData();
          formData.append("file", this.repfile);
          var url = this.tabs == 0 ? apikra + "/kra/kra_check_bulk" : apiinsbo + "/insta_bo_id_upload";
          var axiosThis = this;
          axios
            .post(url, formData, {
              headers: {
                formData,
              },
            })
            .then(function (res) {
              if (axiosThis.tabs == 0) {
                if (res.data && res.data.data && res.data.data.length > 0) {
                  axiosThis.dashboarddata = axiosThis.repfile;
                  axiosThis.showdata = res.data.data;
                } else {
                  axiosThis.showdata = [];
                }
                axiosThis.mainloader = false;
              } else {
                axiosThis.repfile = null;
                axiosThis.snackbar = true;
                axiosThis.snackbarclr = res.data && res.data.msg == "successfully updated" ? "success" : "#2a2a2a";
                axiosThis.snackmsgbar = res.data && res.data.msg ? res.data.msg : res.data;
                axiosThis.getInstaboRep();
              }
            })
            .catch(function (error) {
              axiosThis.repfile = null;
              axiosThis.snackbar = true;
              axiosThis.snackbarclr = "red";
              axiosThis.snackmsgbar = error;
              axiosThis.mainloader = false;
            });
        }
      }
    },
    sstTabtype() {
      this.mainloader = true;
      this.showdata = [];
      this.repfile = null;
      this.search = null;

      if (this.tabs == 1) {
        this.getInstaboRep();
      } else if (this.tabs == 2) {
        this.dayCustom();
      } else if (this.tabs == 4) {
        this.dayCustomkratracker();
      }
      else if (this.tabs == 5) {
        // this.secondataload = true
        // this.dailydatarpapi();
        this.daycustomdailyreport();
        this.mainloader = false;
        // this.reactivationcode()
        // this.rekycreport()
      }
      else if (this.tabs == 7) {
        this.fetchTerminalId();
      }
      else if (this.tabs == 6) {
        // default last 3 days for both NSE and BSE
        const today = new Date();
        const start = new Date(today);
        start.setDate(today.getDate() - 2);
        const startISO = start.toISOString().slice(0, 10)
        const todayISO = today.toISOString().slice(0, 10)
        this.nseFrom = startISO
        this.nseTo = todayISO
        this.bseFrom = startISO
        this.bseTo = todayISO
        this.setRangeLabel('NSE')
        this.setRangeLabel('BSE')
        this.nsepassgetdata()
        this.bsepassgetdata()
        // Load NSE data
        this.exchangeTab = 0;
        this.fetchNseBsePanStatus(0);
        // Load BSE data
        this.fetchNseBsePanStatus(1);
        this.loadPanSyncStatus();
        this.mainloader = false;
      }
      else {
        this.mainloader = false;
      }
    },
    fetchTerminalId() {
      this.terminalLoader = true;
      this.terminalData = [];
      let axiosThis = this;
      axios
        .get(`${apidkyc}/fetch_terminal_id`)
        .then((res) => {
          if (res.data && res.data.terminal_id_data) {
            axiosThis.terminalData = res.data.terminal_id_data;
          }
          axiosThis.terminalLoader = false;
          axiosThis.mainloader = false;
        })
        .catch((error) => {
          console.log(error);
          axiosThis.snackbar = true;
          axiosThis.snackbarclr = "red";
          axiosThis.snackmsgbar = error.message || "Failed to fetch terminal ID data";
          axiosThis.terminalLoader = false;
          axiosThis.mainloader = false;
        });
    },
    openTerminalEdit(item) {
      this.terminalEditItem = { ...item };
      this.terminalEditTerminalId = item.terminal_id || "";
      this.terminalDialog = true;
    },
    openTerminalAdd() {
      this.terminalAddBranchId = "";
      this.terminalAddApCode = "";
      this.terminalAddTerminalId = "";
      if (this.$refs.terminalAddForm) this.$refs.terminalAddForm.resetValidation();
      this.terminalAddDialog = true;
    },
    addTerminalId() {
      this.terminalAddLoader = true;
      let axiosThis = this;
      let modType = !this.terminalAddApCode ? "branch" : "branch&apcode";
      let data = {
        new_branch_id: this.terminalAddBranchId,
        new_ap_code: this.terminalAddApCode,
        new_terminal_id: this.terminalAddTerminalId,
        mod_type: modType,
        data_type: "add",
        log: this.getGenlogs(),
      };
      axios
        .post(`${apidkyc}/terminal_id_updation`, data)
        .then((res) => {
          axiosThis.snackbar = true;
          axiosThis.snackbarclr = "green";
          axiosThis.snackmsgbar = res.data.msg || "Terminal ID added successfully";
          axiosThis.terminalAddDialog = false;
          axiosThis.terminalAddLoader = false;
          axiosThis.fetchTerminalId();
        })
        .catch((error) => {
          console.log(error);
          axiosThis.snackbar = true;
          axiosThis.snackbarclr = "red";
          axiosThis.snackmsgbar = error.response ? error.response.data.msg : error.message || "Failed to add terminal ID";
          axiosThis.terminalAddLoader = false;
        });
    },
    openTerminalDelete(item) {
      this.terminalDeleteItem = { ...item };
      this.terminalDeleteDialog = true;
    },
    deleteTerminalId() {
      this.terminalDeleteLoader = true;
      let axiosThis = this;
      let modType = !this.terminalDeleteItem.ap_code ? "branch" : "branch&apcode";
      let data = {
        exist_branch_id: this.terminalDeleteItem.branch_id,
        exist_ap_code: this.terminalDeleteItem.ap_code,
        mod_type: modType,
        data_type: "delete",
        log: this.getGenlogs(),
      };
      axios
        .post(`${apidkyc}/terminal_id_updation`, data)
        .then((res) => {
          axiosThis.snackbar = true;
          axiosThis.snackbarclr = "green";
          axiosThis.snackmsgbar = res.data.msg || "Terminal ID deleted successfully";
          axiosThis.terminalDeleteDialog = false;
          axiosThis.terminalDeleteLoader = false;
          axiosThis.fetchTerminalId();
        })
        .catch((error) => {
          console.log(error);
          axiosThis.snackbar = true;
          axiosThis.snackbarclr = "red";
          axiosThis.snackmsgbar = error.response ? error.response.data.msg : error.message || "Failed to delete terminal ID";
          axiosThis.terminalDeleteLoader = false;
        });
    },
    updateTerminalId() {
      this.terminalUpdateLoader = true;
      let axiosThis = this;
      let modType = !this.terminalEditItem.ap_code ? "branch" : "branch&apcode";
      let data = {
        exist_branch_id: this.terminalEditItem.branch_id,
        exist_ap_code: this.terminalEditItem.ap_code,
        new_terminal_id: this.terminalEditTerminalId,
        mod_type: modType,
        data_type: "update",
        log: this.getGenlogs(),
      };
      axios
        .post(`${apidkyc}/terminal_id_updation`, data)
        .then((res) => {
          axiosThis.snackbar = true;
          axiosThis.snackbarclr = "green";
          axiosThis.snackmsgbar = res.data.msg || "Terminal ID updated successfully";
          axiosThis.terminalDialog = false;
          axiosThis.terminalUpdateLoader = false;
          axiosThis.fetchTerminalId();
        })
        .catch((error) => {
          console.log(error);
          axiosThis.snackbar = true;
          axiosThis.snackbarclr = "red";
          axiosThis.snackmsgbar = error.response ? error.response.data.msg : error.message || "Failed to update terminal ID";
          axiosThis.terminalUpdateLoader = false;
        });
    },
    getGenlogs(reason, data) {
      var today = new Date();
      var date = today.getFullYear() + "-" + (today.getMonth() + 1) + "-" + today.getDate();
      var time = today.getHours() + ":" + today.getMinutes() + ":" + today.getSeconds();
      var dateTime = date + " " + time;
      var raw = {datetime: dateTime, browser: navigator.appCodeName, emp_emailid: this.uemail, emp_ID: this.uuid, reason: reason ? reason : ""};
      var combo = data ? {...data, ...raw} : raw;
      return combo;
    },
    dailydatarpapi() {
      this.comonloader = true
      this.firstvisible = true
      this.mainloader = true;
      this.dailyreportres = [];
      const axios = require("axios");
      let data = JSON.stringify({
        date: this.date,
      });

      let config = {
        method: "post",
        maxBodyLength: Infinity,
        url: `${apidkyc}/daywise_count_report`,
        headers: {
          "Content-Type": "application/json",
        },
        data: data,
      };
      var axiosThis = this;

      axios
        .request(config)
        .then((response) => {
          axiosThis.comonloader = false

          // console.log(JSON.stringify(response.data));
          axiosThis.mainloader = false;
          axiosThis.firstvisible = true
          axiosThis.dailyreportres = response.data
          console.log("inini", axiosThis.selectredata);

          if (axiosThis.selectredata == "Master code report") {
            window.open("https://ekycbe.mynt.in/" + response.data.location1, "_blank");
            console.log("ififif", response.data.location1);

          }
          if (axiosThis.selectredata == "New Old RM Report") {
            window.open("https://ekycbe.mynt.in/" + response.data.location2, "_blank");
          }
        })
        .catch((error) => {
          console.log(error);
          axiosThis.comonloader = false
          axiosThis.firstvisible = false
          axiosThis.mainloader = false;
          axiosThis.snackbar = true;
          axiosThis.snackbarclr = "red";
          axiosThis.snackmsgbar = error;
        });
    },
    downloadFile() {
      let data = this.tabs != 1 ? this.showdata : this.tabs == 4 ? this.kratrackerres : this.showdata.data;
      let fileName = `${this.tabs == 2 ? "KRA_logs" : this.tabs == 0 ? "KRA-convert" : this.tabs == 4 ? "KRA-Tracker" : "instaBO"}_csv-${new Date().toLocaleDateString()}`;
      const exportType = exportFromJSON.types.csv;
      if (data) exportFromJSON({ data, fileName, exportType });
    },
    getInstaboRep() {
      this.mainloader = true;
      let config = {
        method: "get",
        url: apiinsbo + `/insta_bo_id_data`,
      };

      let axiosThis = this;
      axios
        .request(config)
        .then((res) => {
          if (res.data && res.data.data && axiosThis.tabs == 1) {
            axiosThis.showdata = res.data;
          }
          axiosThis.mainloader = false;
        })
        .catch((error) => {
          axiosThis.mainloader = false;
          console.log(error);
        });
    },

    dayCustom() {
      if (new Date(this.dateSelect2) && new Date(this.dateSelectto) && this.tabs == 2) {
        let dateis = `${new Date(this.dateSelect2).toDateString().slice(3)} ${new Date(this.dateSelect2).toLocaleString("en-US", { hour: "numeric", minute: "numeric", hour12: true })}`;
        let dateto = `${new Date(this.dateSelectto).toDateString().slice(3)} ${new Date(this.dateSelectto).toLocaleString("en-US", { hour: "numeric", minute: "numeric", hour12: true })}`;
        // console.log(dateis, dateto, this.dateSelect2, this.dateSelectto);
        this.alldate = `${dateis.slice(0, 7)} ~ ${dateto.slice(0, 12)}`;
        this.mainloader = true;
        this.getKralogs();
      }
    },
    kraLogTabChange() {
      this.showdata = [];
      this.search = null;
      this.mainloader = true;
      this.getKralogs();
    },
    getKralogs() {
      let config = {
        method: "get",
        url: `${this.kraLogTab == 1 ? apirkyc + "GetKraLogData" : apikra + "/kra/GetKraLogData"}?fromdt=${this.dateSelect2}&todt=${this.dateSelectto}`,
        headers: {},
      };

      let axiosThis = this;
      axios
        .request(config)
        .then((res) => {
          if (res.data && res.data.length > 0) {
            for (let i = 0; i < res.data.length; i++) {
              if (res.data[i].doc_recv == "Y") {
                res.data[i]["path"] = `${this.kraLogTab == 1 ? apidoc : apiekycdoc}?path=${res.data[i].doc_path}`;
              }
              // KYC value (mobile / email / address) for the "Details" column
              res.data[i]["type_detail"] = axiosThis.typeDetail(res.data[i]);
            }
            axiosThis.showdata = res.data;
          }
          axiosThis.mainloader = false;
        })
        .catch((error) => {
          console.log(error);
          axiosThis.mainloader = false;
        });
    },
    // Resolve the KYC value shown in the "Details" column of the KRA log table.
    // The raw KRA payload lives inside item.request as a Python-dict style STRING
    // (single quotes -> not valid JSON), e.g.
    //   "{'ROOT': {'KYCDATA': {'APP_MOB_NO': '9840708682', 'APP_EMAIL': '...'}}}"
    // so we pull the individual fields out with regex rather than JSON.parse.
    // Field shown depends on the modification type (mobile / email / address).
    typeDetail(item) {
      if (!item || !item.request) return "";
      const req = String(item.request);
      // Grab a single KYC field value, handling both 'quoted strings' and bare
      // numbers. The lookahead lets a quoted value contain apostrophes safely.
      const get = (key) => {
        const re = new RegExp("'" + key + "'\\s*:\\s*(?:'([\\s\\S]*?)'(?=\\s*[,}])|([^,'}\\]]+))");
        const m = req.match(re);
        if (!m) return "";
        return (m[1] !== undefined ? m[1] : (m[2] || "")).toString().trim();
      };

      const type = (item.type || "").toString().toLowerCase();
      if (type.includes("mob")) return get("APP_MOB_NO");
      if (type.includes("email")) return get("APP_EMAIL");
      if (type.includes("addr")) {
        return ["APP_PER_ADD1", "APP_PER_ADD2", "APP_PER_ADD3", "APP_PER_CITY", "APP_PER_PINCD"]
          .map(get)
          .filter((v) => v)
          .join(", ");
      }
      return "";
    },
    panStagevalid() {
      if (this.$refs.panform.validate() == true) {
        var c = this.showdata.includes(this.panInput);

        if (!c) {
          this.showdata.push(this.panInput);
        }
        setTimeout(() => {
          this.panInput = "";
        }, 10);
      }
    },
    dayCustomkratracker() {
      if (new Date(this.dateSelect2kra) && new Date(this.dateSelecttokra) && this.tabs == 4) {
        let dateis = `${new Date(this.dateSelect2kra).toDateString().slice(3)} ${new Date(this.dateSelect2kra).toLocaleString("en-US", { hour: "numeric", minute: "numeric", hour12: true })}`;
        let dateto = `${new Date(this.dateSelecttokra).toDateString().slice(3)} ${new Date(this.dateSelecttokra).toLocaleString("en-US", { hour: "numeric", minute: "numeric", hour12: true })}`;
        // console.log(dateis, dateto, this.dateSelect2, this.dateSelectto);
        this.alldatekra = `${dateis.slice(0, 7)} ~ ${dateto.slice(0, 12)}`;
        this.mainloader = true;
        this.kratrackerapi();
      }
    },
    daycustomdailyreport() {
      if (new Date(this.dateSelect2kra) && new Date(this.dateSelecttokra) && this.tabs == 5) {
        let dateis = `${new Date(this.dateSelect2kra).toDateString().slice(3)} ${new Date(this.dateSelect2kra).toLocaleString("en-US", { hour: "numeric", minute: "numeric", hour12: true })}`;
        let dateto = `${new Date(this.dateSelecttokra).toDateString().slice(3)} ${new Date(this.dateSelecttokra).toLocaleString("en-US", { hour: "numeric", minute: "numeric", hour12: true })}`;
        // console.log(dateis, dateto, this.dateSelect2, this.dateSelectto);
        this.alldatekra = `${dateis.slice(0, 7)} ~ ${dateto.slice(0, 12)}`;
        // this.mainloader = true;
        this.monthwiserportapi();
      }
    },

    kratrackerapi() {
      this.kracountdata = "";
      this.kratrackerres = [];
      const axios = require("axios");
      let data = JSON.stringify({
        start_date: this.dateSelect2kra,
        end_date: this.dateSelecttokra,
      });

      let config = {
        method: "post",
        maxBodyLength: Infinity,
        url: `${apikra}/kra/kra_tracker`,
        headers: {
          "Content-Type": "application/json",
        },
        data: data,
      };
      var axiosThis = this;
      axios
        .request(config)
        .then((response) => {
          // console.log(JSON.stringify(response.data));
          axiosThis.mainloader = false;
          axiosThis.kratrackerres = response.data.data;
          axiosThis.kracountdata = response.data;
        })
        .catch((error) => {
          console.log(error);
          axiosThis.mainloader = false;
        });
    },
    dateClear() {
      this.dateSelect2kra = "";
      this.dateSelecttokra = "";
      this.alldatekra = "";
      this.mainloader = true;
      this.kratrackerapi();
    },
    downloadFilekra() {
      let data = this.filteredItems;
      let fileName = `${"kratracker"}_csv-${new Date().toLocaleDateString()}`;
      const exportType = exportFromJSON.types.csv;
      if (data) exportFromJSON({ data, fileName, exportType });
    },
    downloadNseExcel() {
      let data = this.filteredNsePanItems;
      let fileName = `NSE_PAN_Status-${new Date().toLocaleDateString()}`;
      const exportType = exportFromJSON.types.xls;
      if (data) exportFromJSON({ data, fileName, exportType });
    },
    downloadBseExcel() {
      let data = this.filteredBsePanItems;
      let fileName = `BSE_PAN_Status-${new Date().toLocaleDateString()}`;
      const exportType = exportFromJSON.types.xls;
      if (data) exportFromJSON({ data, fileName, exportType });
    },

    monthwiserportapi() {
      this.mothwisres = [];
      this.secondataload = true;
      this.secondreport = true;
      const axios = require("axios");
      let data = JSON.stringify({
        start_date: this.dateSelect2kra,
        end_date: this.dateSelecttokra,
      });

      let config = {
        method: "post",
        maxBodyLength: Infinity,
        url: "https://branchbe.mynt.in/month_wise_report",
        headers: {
          "Content-Type": "application/json",
        },
        data: data,
      };
      var axiosThis = this;
      axios
        .request(config)
        .then((response) => {
          // console.log(JSON.stringify(response.data));
          axiosThis.secondreport = true;
          axiosThis.secondataload = false;
          axiosThis.mothwisres = response.data;
        })
        .catch((error) => {
          console.log(error);
          axiosThis.secondreport = false;
          axiosThis.secondataload = false;
          axiosThis.snackbar = true;
          axiosThis.snackbarclr = "red";
          axiosThis.snackmsgbar = error;
        });
    },

    reactivationcode() {
      this.comonloader = true
      this.thirdvisible = true
      this.reatvatinloda = true
      this.reativatoires = []
      const axios = require('axios');
      let data = JSON.stringify({
        "date": this.date
      });

      let config = {
        method: "post",
        maxBodyLength: Infinity,
        url: `${apidkyc}/today_reactivation`,
        headers: {
          "Content-Type": "application/json",
        },
        data: data,
      };
      var axiosThis = this;
      axios
        .request(config)
        .then((response) => {
          // console.log(JSON.stringify(response.data));
          axiosThis.comonloader = false
          axiosThis.reatvatinloda = false
          axiosThis.thirdvisible = true
          axiosThis.reativatoires = response.data
          if (axiosThis.selectredata == "Reactivation report") {
            window.open("https://ekycbe.mynt.in/" + response.data.file_loc, "_blank");
          }
        })
        .catch((error) => {
          console.log(error);
          axiosThis.comonloader = false
          axiosThis.thirdvisible = false
          axiosThis.snackbar = true;
          axiosThis.snackbarclr = "red";
          axiosThis.snackmsgbar = error;
          axiosThis.reatvatinloda = false;
        });

    },

    downloadselectreport() {
      this.comonloader = true
      if (this.selectredata == "Master code report") {
        this.dailydatarpapi()
      }
      else if (this.selectredata == "New Old RM Report") {
        this.dailydatarpapi()
      }
      else if (this.selectredata == "Reactivation report") {
        this.reactivationcode()
      }
      else if (this.selectredata == "REKYC Report") {
        this.rekycreport()
      } else if (this.selectredata == "Overall Report") {
        this.overallreport()
      }
      else {
        this.snackbar = true;
        this.snackbarclr = "red";
        this.snackmsgbar = "Please select the report Name";
        this.comonloader = false
      }
    },
    overallreport() {
      this.comonloader = true
      const axios = require('axios');
      let data = JSON.stringify({
        "date": this.date
      });

      let config = {
        method: 'post',
        maxBodyLength: Infinity,
        url: 'https://rekycbe.mynt.in/overall_report',
        headers: {
          'Content-Type': 'application/json'
        },
        data: data
      };
      var axiosThis = this
      axios.request(config)
        .then((response) => {
          axiosThis.comonloader = false

          // console.log(JSON.stringify(response.data));
          if (response.data.stat == "Ok") {
            window.open("https://rekycbe.mynt.in/" + response.data.data, "_blank");

          }
        })
        .catch((error) => {
          console.log(error);
          axiosThis.comonloader = false
          axiosThis.snackbar = true;
          axiosThis.snackbarclr = "red";
          axiosThis.snackmsgbar = error;
        });

    },
    downloadEkycForms() {
      if (!this.ekycFormsDate) {
        this.snackbar = true;
        this.snackbarclr = "red";
        this.snackmsgbar = "Please select a date";
        return;
      }
      const startDate = this.ekycFormsDate;
      const nextDay = new Date(startDate);
      nextDay.setDate(nextDay.getDate() + 1);
      const endDate = nextDay.toISOString().slice(0, 10);
      const url = `${apiekyc}/esigned_zip?start_date=${startDate}&end_date=${endDate}`;
      window.open(url, "_blank");
    },
    downloadRekycForms() {
      if (!this.rekycFormsDate) {
        this.snackbar = true;
        this.snackbarclr = "red";
        this.snackmsgbar = "Please select a date";
        return;
      }
      // backend now matches ISO timestamps: pass the picked date as-is (YYYY-MM-DD), not DD-MM-YYYY
      const selectedDate = this.rekycFormsDate;
      const url = `${apirkyc}e_signed_zip?start_date=${selectedDate}`;
      window.open(url, "_blank");
    }
  },
  computed: {
    // BSE allows one PAN status request per 2 minutes
    panSecondsLeft() {
      if (!this.panSync || !this.panSync.last_run_at) return 0
      const elapsed = (this.panNow - this.parsePanSyncDate(this.panSync.last_run_at)) / 1000
      return Math.max(0, Math.ceil(120 - elapsed))
    },
    panCountdown() {
      const s = this.panSecondsLeft
      return `${Math.floor(s / 60)}:${String(s % 60).padStart(2, '0')}`
    },
    // never includes tracebacks; all dynamic text is escaped
    panSyncHtml() {
      const esc = (t) => String(t).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;')
      const s = this.panSync
      // inline styles because v-html content is not touched by scoped CSS
      const pill = (c, bg, border, dot, body) =>
        `<span style="display:inline-flex;align-items:center;gap:8px;padding:5px 12px;border-radius:8px;` +
        `background:${bg};border:1px solid ${border};color:${c};font-weight:500;white-space:nowrap">` +
        `<span style="width:8px;height:8px;border-radius:50%;background:${dot};box-shadow:0 0 0 3px ${border}"></span>${body}</span>`
      const tag = (t) =>
        `<span style="padding:0 8px;border-radius:6px;background:#fff;border:1px solid currentColor;font-size:11px;font-weight:600">${t}</span>`
      const muted = (t) => `<span style="opacity:0.75">${t}</span>`
      if (!s) return pill('#616161', '#f5f5f5', '#e0e0e0', '#9e9e9e', 'Data has not been updated yet')
      const how = s.triggered_by === 'auto' ? 'Auto sync' : 'Manual update'
      if (s.last_status === 'success') {
        // app primary blue (#0037B7) with a green live dot
        return pill('#0037B7', '#EEF2FB', '#C9D6F5', '#2e7d32',
          `${muted('Data up to date · Last updated on')} ${esc(this.formatPanDate(s.last_success_at, true))} ${tag(how)}`)
      }
      const mark = (x) => {
        const v = s.message ? s.message[x] : null
        if (v === 'success') return tag(`${x}: Updated ✓`)
        const tip = Array.isArray(v) ? v.map((e) => e && e.error).filter(Boolean).join(', ') : ''
        return `<span title="${esc(tip)}">${tag(`${x}: Failed ✗`)}</span>`
      }
      let html = pill('#b71c1c', '#ffebee', '#ffcdd2', '#e53935',
        `${muted('Last update failed on')} ${esc(this.formatPanDate(s.last_run_at, true))} ${tag(how)} ${mark('NSE')} ${mark('BSE')}`)
      if (s.last_success_at) {
        html += ` &nbsp; <span class="grey--text">Last successful update: ${esc(this.formatPanDate(s.last_success_at, true))}</span>`
      }
      return html
    },
    kraLogHeaders() {
      // Rekyc tab uses the client code in place of the mobile number, and the
      // "Modification Details" column (KYCDATA value) only applies to Rekyc.
      return this.kralogheaders
        .filter((h) => h.value !== "type_detail" || this.kraLogTab == 1)
        .map((h) =>
          h.value === "mobile"
            ? { ...h, text: this.kraLogTab == 1 ? "Client code" : "Mobile" }
            : h
        );
    },
    filteredItems() {
      return this.kratrackerres.filter((item) => {
        return Object.keys(this.filters).every((key) => {
          return !this.filters[key] || this.filters[key].length === 0 || this.filters[key].includes(item[key]);
        });
      });
    },
    filteredNsePanItems() {
      if (!this.nsePanSearch) return this.nsePanData
      const q = this.nsePanSearch.toLowerCase()
      return this.nsePanData.filter((row) =>
        Object.values(row).some((val) => (val !== null && val !== undefined && String(val).toLowerCase().includes(q)))
      )
    },
    filteredBsePanItems() {
      if (!this.bsePanSearch) return this.bsePanData
      const q = this.bsePanSearch.toLowerCase()
      return this.bsePanData.filter((row) =>
        Object.values(row).some((val) => (val !== null && val !== undefined && String(val).toLowerCase().includes(q)))
      )
    }
  },
  watch: {
    snackbar(val) {
      if (!val) this.snackTimeout = 5000 // restore default after a persistent PAN snackbar
    },
    exchangeTab(newVal) {
      if (this.tabs == 6) {
        if (newVal === 0) {
          this.nsepassgetdata();
          this.fetchNseBsePanStatus();
        } else if (newVal === 1) {
          this.bsepassgetdata();
          this.fetchNseBsePanStatus();
        }
      }
    },
  },
};
</script>

<style>
@import "../assets/style.css";

.custom-autocomplete {
  max-width: 300px;
  height: 50px;
  font-size: 14px;
}

.custom-autocomplete .v-input__control {
  height: 50px;
}

.custom-autocomplete .v-input__label {
  font-size: 12px;
}
</style>
